// @ts-nocheck
import * as Types from '@src/types/graphql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as React from 'react';
import * as ApolloReactComponents from '@apollo/client/react/components';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
export type RuleValidateFieldsMutationVariables = Types.Exact<{
  input: Types.RuleValidateInput;
  productInput: Types.ConfiguratorProductInput;
}>;


export type RuleValidateFieldsMutation = { __typename?: 'Mutation', ruleValidateFields: { __typename?: 'RuleValidateResponse', listFiveMod?: Array<string | null> | null, listThreeMod?: Array<string | null> | null, listScale?: Array<string | null> | null, listPurification?: Array<string | null> | null, listModification?: Array<string | null> | null, listFormat?: Array<string | null> | null, listConcentration?: Array<string | null> | null, listTubes?: Array<string | null> | null, listMinimumYield?: number | null, listAmount?: Array<string | null> | null, listPurityLevel?: Array<string | null> | null, listNterminalMod?: Array<string | null> | null, listCterminalMod?: Array<string | null> | null, listQuantitation?: Array<string | null> | null, listInternalMod?: Array<string | null> | null, baseCount?: number | null, molecularWeight?: string | null, primerDimer?: string | null, meltingTemperature?: string | null, secondaryStructure?: string | null, gcContent?: string | null, listLabeledAminoAcids?: Array<string | null> | null, listConjugation?: Array<string | null> | null, listConjugationAmount?: Array<string | null> | null, listConjugationChemistry?: Array<string | null> | null, listAdditionalCarrierProtein?: Array<string | null> | null, listServices?: Array<string | null> | null, listAdditionalServices?: Array<string | null> | null, additionalServices?: Array<string | null> | null, sequence?: string | null, isLNABaseEnable?: boolean | null, listErrors?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null, listWarnings?: Array<{ __typename?: 'ListWarning', key?: string | null, value?: string | null } | null> | null, serverError?: { __typename?: 'ListError', key?: string | null, value?: string | null } | null } };

export type SessionFieldsMutationVariables = Types.Exact<{
  input: Array<Types.InputMaybe<Types.SessionInput>> | Types.InputMaybe<Types.SessionInput>;
  productInput: Types.ConfiguratorProductInput;
}>;


export type SessionFieldsMutation = { __typename?: 'Mutation', sessionFields: { __typename?: 'SessionResponse', result?: number | null } };

export type TubeTotalValidationMutationVariables = Types.Exact<{
  input: Array<Types.InputMaybe<Types.SessionInput>> | Types.InputMaybe<Types.SessionInput>;
  productInput: Types.ConfiguratorProductInput;
}>;


export type TubeTotalValidationMutation = { __typename?: 'Mutation', tubeTotalValidation?: Array<{ __typename?: 'tubeTotalValidationResponse', oligoId?: number | null, epsilon?: number | null, listErrors?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null, serverError?: { __typename?: 'ListError', key?: string | null, value?: string | null } | null }> | null };

export type UploadCopyPasteTextMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.Scalars['String']['input']>;
  productInput: Types.ConfiguratorProductInput;
  isOverride?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  autogenerateAntisense?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type UploadCopyPasteTextMutation = { __typename?: 'Mutation', uploadCopyPasteText?: { __typename?: 'UploadCopyPasteResponse', key?: string | null, value?: string | null, serverError?: { __typename?: 'ListError', key?: string | null, value?: string | null } | null } | null };

export type RuleValidatePlateMutationVariables = Types.Exact<{
  input: Types.RuleValidatePlateInput;
  productInput: Types.ConfiguratorProductInput;
}>;


export type RuleValidatePlateMutation = { __typename?: 'Mutation', ruleValidatePlate: { __typename?: 'RuleValidateResponsePlate', listFiveMod?: Array<string | null> | null, listThreeMod?: Array<string | null> | null, listScale?: Array<string | null> | null, listPurification?: Array<string | null> | null, listModification?: Array<string | null> | null, listFormat?: Array<string | null> | null, listConcentration?: Array<string | null> | null, listTubes?: Array<string | null> | null, listMinimumYield?: number | null, listAmount?: Array<string | null> | null, listPurityLevel?: Array<string | null> | null, listNterminalMod?: Array<string | null> | null, listCterminalMod?: Array<string | null> | null, listQuantitation?: Array<string | null> | null, listInternalMod?: Array<string | null> | null, listOverhang?: Array<string | null> | null, baseCount?: number | null, antisenseBaseCount?: number | null, molecularWeight?: string | null, primerDimer?: string | null, meltingTemperature?: string | null, secondaryStructure?: string | null, gcContent?: string | null, antisenseMolecularWeight?: string | null, antisensePrimerDimer?: string | null, antisenseMeltingTemperature?: string | null, antisenseGcContent?: string | null, antisenseSecondaryStructure?: string | null, technicalSequence?: string | null, listErrors?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null, listWarning?: Array<{ __typename?: 'ListWarning', key?: string | null, value?: string | null } | null> | null, serverError?: { __typename?: 'ListError', key?: string | null, value?: string | null } | null } };

export type FastduplexRuleValidationMutationVariables = Types.Exact<{
  input: Types.FastDuplexValidateInput;
  productInput: Types.ConfiguratorProductInput;
}>;


export type FastduplexRuleValidationMutation = { __typename?: 'Mutation', fastduplexRuleValidation: { __typename?: 'FastDuplexValidateResponse', listFiveMod?: Array<string | null> | null, listThreeMod?: Array<string | null> | null, listScale?: Array<string | null> | null, listPurification?: Array<string | null> | null, listModification?: Array<string | null> | null, listFormat?: Array<string | null> | null, listConcentration?: Array<string | null> | null, listTubes?: Array<string | null> | null, listMinimumYield?: number | null, listAmount?: Array<string | null> | null, listPurityLevel?: Array<string | null> | null, listNterminalMod?: Array<string | null> | null, listCterminalMod?: Array<string | null> | null, listQuantitation?: Array<string | null> | null, listInternalMod?: Array<string | null> | null, listOverhang?: Array<string | null> | null, baseCount?: string | null, molecularWeight?: string | null, primerDimer?: string | null, meltingTemperature?: string | null, secondaryStructure?: string | null, gcContent?: string | null, antisenseBaseCount?: string | null, antisenseMolecularWeight?: string | null, antisensePrimerDimer?: string | null, antisenseMeltingTemperature?: string | null, antisenseGcContent?: string | null, antisenseSecondaryStructure?: string | null, sequence?: string | null, listErrors?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null, serverError?: { __typename?: 'ListError', key?: string | null, value?: string | null } | null } };

export type PlateSessionFieldMutationVariables = Types.Exact<{
  input: Array<Types.InputMaybe<Types.PlatesInput>> | Types.InputMaybe<Types.PlatesInput>;
  productInput: Types.ConfiguratorProductInput;
}>;


export type PlateSessionFieldMutation = { __typename?: 'Mutation', plateSessionField: boolean };

export type PlateTotalValidationMutationVariables = Types.Exact<{
  input: Array<Types.InputMaybe<Types.PlatesInput>> | Types.InputMaybe<Types.PlatesInput>;
  productInput: Types.ConfiguratorProductInput;
}>;


export type PlateTotalValidationMutation = { __typename?: 'Mutation', plateTotalValidation?: { __typename?: 'PlatesDataResponse', response?: Array<{ __typename?: 'PlatesResponse', error?: string | null, wellList?: Array<{ __typename?: 'WelllistResponse', id?: number | null, oligoId?: number | null, countryCode?: string | null, listNgso?: Array<string | null> | null, errorType?: string | null, listError?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null } | null> | null, biTubeWellList?: Array<{ __typename?: 'BiTubeWelllistResponse', id?: number | null, oligoId?: number | null, countryCode?: string | null, errorType?: string | null, listError?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null, listWarning?: Array<{ __typename?: 'ListWarning', key?: string | null, value?: string | null } | null> | null } | null> | null } | null> | null, serverError?: { __typename?: 'ListError', key?: string | null, value?: string | null } | null } | null };

export type PlatesDataResponseFragment = { __typename?: 'PlatesDataResponse', response?: Array<{ __typename?: 'PlatesResponse', error?: string | null, wellList?: Array<{ __typename?: 'WelllistResponse', id?: number | null, oligoId?: number | null, countryCode?: string | null, listNgso?: Array<string | null> | null, errorType?: string | null, listError?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null } | null> | null, biTubeWellList?: Array<{ __typename?: 'BiTubeWelllistResponse', id?: number | null, oligoId?: number | null, countryCode?: string | null, errorType?: string | null, listError?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null, listWarning?: Array<{ __typename?: 'ListWarning', key?: string | null, value?: string | null } | null> | null } | null> | null } | null> | null, serverError?: { __typename?: 'ListError', key?: string | null, value?: string | null } | null };

export type CopyPasteTubeMutationVariables = Types.Exact<{
  input: Types.Scalars['String']['input'];
  productInput: Types.ConfiguratorProductInput;
  isOverride?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  isDForm?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type CopyPasteTubeMutation = { __typename?: 'Mutation', copyPasteTube?: { __typename?: 'UploadCopyPasteResponse', key?: string | null, value?: string | null, serverError?: { __typename?: 'ListError', key?: string | null, value?: string | null } | null } | null };

export type TubePriceCallMutationVariables = Types.Exact<{
  input: Array<Types.InputMaybe<Types.SessionInput>> | Types.InputMaybe<Types.SessionInput>;
  productInput: Types.ConfiguratorProductInput;
}>;


export type TubePriceCallMutation = { __typename?: 'Mutation', tubePriceCall?: { __typename?: 'TubePriceCall', result?: Array<{ __typename?: 'RuleValidateResponse', epsilon?: number | null, listFiveMod?: Array<string | null> | null, listThreeMod?: Array<string | null> | null, listScale?: Array<string | null> | null, listPurification?: Array<string | null> | null, listModification?: Array<string | null> | null, listFormat?: Array<string | null> | null, listConcentration?: Array<string | null> | null, listTubes?: Array<string | null> | null, listMinimumYield?: number | null, listAmount?: Array<string | null> | null, listPurityLevel?: Array<string | null> | null, listNterminalMod?: Array<string | null> | null, listCterminalMod?: Array<string | null> | null, listQuantitation?: Array<string | null> | null, listInternalMod?: Array<string | null> | null, baseCount?: number | null, molecularWeight?: string | null, primerDimer?: string | null, meltingTemperature?: string | null, secondaryStructure?: string | null, gcContent?: string | null, isOverridden?: boolean | null, name?: string | null, sequence?: string | null, fiveMod?: string | null, purification?: string | null, format?: string | null, concentration?: string | null, tubes?: string | null, price?: string | null, scale?: string | null, applyToAll?: boolean | null, fullSOligoBackbone?: boolean | null, productType?: string | null, threeMod?: string | null, countryCode?: string | null, currencySymbol?: string | null, currency?: string | null, material?: string | null, brand?: string | null, priceHeaderError?: string | null, cartId?: string | null, itemId?: string | null, oligoId?: number | null, listErrors?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null, serverError?: { __typename?: 'ListError', key?: string | null, value?: string | null } | null } | null> | null } | null };

export type TubePriceCallFragment = { __typename?: 'TubePriceCall', result?: Array<{ __typename?: 'RuleValidateResponse', epsilon?: number | null, listFiveMod?: Array<string | null> | null, listThreeMod?: Array<string | null> | null, listScale?: Array<string | null> | null, listPurification?: Array<string | null> | null, listModification?: Array<string | null> | null, listFormat?: Array<string | null> | null, listConcentration?: Array<string | null> | null, listTubes?: Array<string | null> | null, listMinimumYield?: number | null, listAmount?: Array<string | null> | null, listPurityLevel?: Array<string | null> | null, listNterminalMod?: Array<string | null> | null, listCterminalMod?: Array<string | null> | null, listQuantitation?: Array<string | null> | null, listInternalMod?: Array<string | null> | null, baseCount?: number | null, molecularWeight?: string | null, primerDimer?: string | null, meltingTemperature?: string | null, secondaryStructure?: string | null, gcContent?: string | null, isOverridden?: boolean | null, name?: string | null, sequence?: string | null, fiveMod?: string | null, purification?: string | null, format?: string | null, concentration?: string | null, tubes?: string | null, price?: string | null, scale?: string | null, applyToAll?: boolean | null, fullSOligoBackbone?: boolean | null, productType?: string | null, threeMod?: string | null, countryCode?: string | null, currencySymbol?: string | null, currency?: string | null, material?: string | null, brand?: string | null, priceHeaderError?: string | null, cartId?: string | null, itemId?: string | null, oligoId?: number | null, listErrors?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null, serverError?: { __typename?: 'ListError', key?: string | null, value?: string | null } | null } | null> | null };

export type BitubeTotalValidationMutationVariables = Types.Exact<{
  input: Array<Types.InputMaybe<Types.SessionInput>> | Types.InputMaybe<Types.SessionInput>;
  productInput: Types.ConfiguratorProductInput;
}>;


export type BitubeTotalValidationMutation = { __typename?: 'Mutation', bitubeTotalValidation?: Array<{ __typename?: 'BitubeTotalValidationResponse', price?: string | null, currencySymbol?: string | null, currency?: string | null, brand?: string | null, material?: string | null, listErrors?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null, serverError?: { __typename?: 'ListError', key?: string | null, value?: string | null } | null }> | null };

export type UploadTubesFromFileMutationVariables = Types.Exact<{
  input: Types.Scalars['String']['input'];
  productInput: Types.ConfiguratorProductInput;
  isOverride?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  isDForm?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  startRow?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type UploadTubesFromFileMutation = { __typename?: 'Mutation', uploadTubesFromFile?: { __typename?: 'UploadFileResponse', key?: string | null, value?: string | null, serverError?: { __typename?: 'ListError', key?: string | null, value?: string | null } | null } | null };

export type PlateSpecificationValidationMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Array<Types.InputMaybe<Types.WelllistInput>> | Types.InputMaybe<Types.WelllistInput>>;
  productInput: Types.ConfiguratorProductInput;
}>;


export type PlateSpecificationValidationMutation = { __typename?: 'Mutation', plateSpecificationValidation?: { __typename?: 'WellSpecificationResponse', response?: Array<{ __typename?: 'WellSpecifications', id: number, listPurification?: Array<string | null> | null, listScale?: Array<string | null> | null, listFormat?: Array<string | null> | null, listAmount?: Array<string | null> | null } | null> | null, serverError?: { __typename?: 'ListError', key?: string | null, value?: string | null } | null } | null };

export type WellSpecificationResponseFragment = { __typename?: 'WellSpecificationResponse', response?: Array<{ __typename?: 'WellSpecifications', id: number, listPurification?: Array<string | null> | null, listScale?: Array<string | null> | null, listFormat?: Array<string | null> | null, listAmount?: Array<string | null> | null } | null> | null, serverError?: { __typename?: 'ListError', key?: string | null, value?: string | null } | null };

export type DuplexSpecificationValidationMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Array<Types.InputMaybe<Types.BiTubeWellListInput>> | Types.InputMaybe<Types.BiTubeWellListInput>>;
  productInput: Types.ConfiguratorProductInput;
}>;


export type DuplexSpecificationValidationMutation = { __typename?: 'Mutation', duplexSpecificationValidation?: { __typename?: 'WellSpecificationResponse', response?: Array<{ __typename?: 'WellSpecifications', id: number, listPurification?: Array<string | null> | null, listScale?: Array<string | null> | null, listFormat?: Array<string | null> | null, listAmount?: Array<string | null> | null } | null> | null, serverError?: { __typename?: 'ListError', key?: string | null, value?: string | null } | null } | null };

export type BiWellSpecificationResponseFragment = { __typename?: 'WellSpecificationResponse', response?: Array<{ __typename?: 'WellSpecifications', id: number, listPurification?: Array<string | null> | null, listScale?: Array<string | null> | null, listFormat?: Array<string | null> | null, listAmount?: Array<string | null> | null } | null> | null, serverError?: { __typename?: 'ListError', key?: string | null, value?: string | null } | null };

export type ValidatePlateShippingMutationVariables = Types.Exact<{
  input: Array<Types.InputMaybe<Types.PlatesInput>> | Types.InputMaybe<Types.PlatesInput>;
  productInput: Types.ConfiguratorProductInput;
}>;


export type ValidatePlateShippingMutation = { __typename?: 'Mutation', validatePlateShipping?: { __typename?: 'PlateShippingResponse', listShipment?: Array<string | null> | null, listExcessMaterial?: Array<string | null> | null, listProductPackage?: Array<string | null> | null, serverError?: { __typename?: 'ListError', key?: string | null, value?: string | null } | null } | null };

export type BiTubePriceCallMutationVariables = Types.Exact<{
  product: Types.ConfiguratorProductInput;
}>;


export type BiTubePriceCallMutation = { __typename?: 'Mutation', biTubePriceCall?: Array<{ __typename?: 'BitubeTotalValidationResponse', price?: string | null, currencySymbol?: string | null, currency?: string | null, material?: string | null, brand?: string | null, priceHeaderError?: string | null, listErrors?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null, serverError?: { __typename?: 'ListError', key?: string | null, value?: string | null } | null }> | null };

export type FileUploadPlateMutationVariables = Types.Exact<{
  input: Array<Types.InputMaybe<Types.PlateListInput>> | Types.InputMaybe<Types.PlateListInput>;
  productInput: Types.ConfiguratorProductInput;
  isOverride?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  autogenerateAntisense?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  startRow?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type FileUploadPlateMutation = { __typename?: 'Mutation', fileUploadPlate?: { __typename?: 'UploadCopyPasteResponse', key?: string | null, value?: string | null, serverError?: { __typename?: 'ListError', key?: string | null, value?: string | null } | null } | null };

export type ConfAddToMiniCartMutationVariables = Types.Exact<{
  input: Types.ConfiguratorAddToMiniCartInput;
}>;


export type ConfAddToMiniCartMutation = { __typename?: 'Mutation', confAddToMiniCart?: { __typename?: 'ConfiguratorMiniCartResponse', result?: string | null, serverError?: { __typename?: 'ListError', key?: string | null, value?: string | null } | null } | null };

export type MilliplexTotalValidationMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Array<Types.InputMaybe<Types.MilliplexDataInput>> | Types.InputMaybe<Types.MilliplexDataInput>>;
  productInput: Types.ConfiguratorProductInput;
}>;


export type MilliplexTotalValidationMutation = { __typename?: 'Mutation', milliplexTotalValidation?: Array<{ __typename?: 'milliplexTotalValidationResponse', listResearchAreas?: Array<string | null> | null, listSpecies?: Array<string | null> | null, checkedProductIdList?: Array<string | null> | null, listAnalytes?: Array<string | null> | null, listSensitivity?: Array<string | null> | null, researchAreas?: Array<string | null> | null, currencySymbol?: string | null, brand?: string | null, currency?: string | null, analytes?: Array<string | null> | null, listWarning?: Array<string | null> | null, species?: string | null, sensitivity?: string | null, mapMates?: string | null, itemId?: string | null, cartId?: string | null, comments?: string | null, additionalComments?: string | null, productType?: string | null, countryCode?: string | null, priceHeaderError?: string | null, oligoId?: number | null, researcher?: string | null, id?: number | null, listError?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null, listMilliplexAssayModel?: Array<{ __typename?: 'MilliplexSearchResponse', requestDate?: string | null, responseDate?: string | null, count?: number | null, version?: string | null, term?: Array<string | null> | null, termCount?: string | null, assays?: Array<{ __typename?: 'KitsItem', panelId?: string | null, panelName?: string | null, assayType?: string | null, customPremixedAvailable?: Array<string | null> | null, requireSample?: string | null, researchAreaOracle?: Array<string | null> | null, species?: string | null, researchAreas?: Array<string | null> | null, type?: string | null, listSampleType?: Array<string | null> | null, customPremixSelection?: string | null, spaceSaverSelection?: string | null, decisionTableVer?: string | null, listAnalytes?: Array<string | null> | null, selectedAnalytes?: Array<string | null> | null, price?: string | null, allAnalytesSelected?: string | null, mutualAnalytesList?: Array<Array<string | null> | null> | null, analytes?: Array<string | null> | null, quantity?: string | null, material?: string | null, spaceSaver?: string | null, name?: string | null, sampleType?: string | null, id?: number | null, productTotal?: string | null, listSearchResultModelErrors?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null, listWarnings?: Array<{ __typename?: 'ListWarning', key?: string | null, value?: string | null } | null> | null } | null> | null } | null> | null, serverError?: { __typename?: 'ListError', key?: string | null, value?: string | null } | null } | null> | null };

export type CustomCrisprTotalValidationMutationVariables = Types.Exact<{
  input: Array<Types.InputMaybe<Types.CustomCrisprSessionInput>> | Types.InputMaybe<Types.CustomCrisprSessionInput>;
  productInput: Types.ConfiguratorProductInput;
}>;


export type CustomCrisprTotalValidationMutation = { __typename?: 'Mutation', customCrisprTotalValidation?: Array<{ __typename?: 'CustomCrisprTotalValidationResponse', listPhysicalMaterials?: Array<string | null> | null, physicalMaterial?: string | null, listLentiviralBackbones?: Array<string | null> | null, listViralTiters?: Array<string | null> | null, listVolumes?: Array<string | null> | null, listAliquotings?: Array<string | null> | null, listVectors?: Array<string | null> | null, listAmount?: Array<string | null> | null, listSpecies?: Array<string | null> | null, listPurification?: Array<string | null> | null, listScale?: Array<string | null> | null, listModification?: Array<string | null> | null, listStructure?: Array<string | null> | null, listFormat?: Array<string | null> | null, vector?: string | null, lentiviralBackbone?: string | null, viralTiter?: string | null, volume?: string | null, aliquoting?: string | null, amount?: string | null, pageNo?: number | null, scale?: string | null, purification?: string | null, format?: string | null, modification?: string | null, species?: string | null, structure?: string | null, material?: string | null, itemId?: string | null, cartId?: string | null, modifiedSequence?: string | null, modifiedTechnicalSequence?: string | null, listError?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null, listCompanionProducts?: Array<{ __typename?: 'ListCompanionProducts', key?: string | null, value?: string | null } | null> | null, listSubModels?: Array<{ __typename?: 'ListSubModel', name?: string | null, geneId?: string | null, geneSymbol?: string | null, sequence?: string | null, id?: number | null, isOverridden?: boolean | null, isCurrentForm?: boolean | null, baseCount?: number | null, cartId?: string | null, itemId?: string | null, listSubModelErrors?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null } | null> | null, serverError?: { __typename?: 'ListError', key?: string | null, value?: string | null } | null }> | null };

export type CustomCrisprSaveToSessionMutationVariables = Types.Exact<{
  input: Array<Types.InputMaybe<Types.CustomCrisprSessionInput>> | Types.InputMaybe<Types.CustomCrisprSessionInput>;
  productInput: Types.ConfiguratorProductInput;
}>;


export type CustomCrisprSaveToSessionMutation = { __typename?: 'Mutation', customCrisprSaveToSession: { __typename?: 'SessionResponse', result?: number | null } };

export type MilliplexSaveToSessionMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Array<Types.InputMaybe<Types.MilliplexDataInput>> | Types.InputMaybe<Types.MilliplexDataInput>>;
  productInput: Types.ConfiguratorProductInput;
}>;


export type MilliplexSaveToSessionMutation = { __typename?: 'Mutation', milliplexSaveToSession?: { __typename?: 'SessionResponse', result?: number | null } | null };

export type MilliplexPriceCallMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Array<Types.InputMaybe<Types.MilliplexDataInput>> | Types.InputMaybe<Types.MilliplexDataInput>>;
  productInput: Types.ConfiguratorProductInput;
}>;


export type MilliplexPriceCallMutation = { __typename?: 'Mutation', milliplexPriceCall?: { __typename?: 'MilliplexPriceResponse', priceHeaderError?: string | null, currencySymbol?: string | null, brand?: string | null, currency?: string | null, listMilliplexAssayModel?: Array<{ __typename?: 'MilliplexSearchResponse', requestDate?: string | null, responseDate?: string | null, count?: number | null, version?: string | null, term?: Array<string | null> | null, termCount?: string | null, assays?: Array<{ __typename?: 'KitsItem', panelId?: string | null, panelName?: string | null, assayType?: string | null, customPremixedAvailable?: Array<string | null> | null, requireSample?: string | null, researchAreaOracle?: Array<string | null> | null, species?: string | null, researchAreas?: Array<string | null> | null, type?: string | null, listSampleType?: Array<string | null> | null, customPremixSelection?: string | null, spaceSaverSelection?: string | null, decisionTableVer?: string | null, listAnalytes?: Array<string | null> | null, selectedAnalytes?: Array<string | null> | null, price?: string | null, allAnalytesSelected?: string | null, mutualAnalytesList?: Array<Array<string | null> | null> | null, analytes?: Array<string | null> | null, quantity?: string | null, material?: string | null, spaceSaver?: string | null, name?: string | null, sampleType?: string | null, id?: number | null, productTotal?: string | null, listSearchResultModelErrors?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null, listWarnings?: Array<{ __typename?: 'ListWarning', key?: string | null, value?: string | null } | null> | null } | null> | null } | null> | null, serverError?: { __typename?: 'ListError', key?: string | null, value?: string | null } | null } | null };

export type RuleValidateDuplexMutationVariables = Types.Exact<{
  input: Types.RuleValidateDuplexInput;
  productInput: Types.ConfiguratorProductInput;
}>;


export type RuleValidateDuplexMutation = { __typename?: 'Mutation', ruleValidateDuplex: { __typename?: 'RuleValidateResponsePlate', listFiveMod?: Array<string | null> | null, listThreeMod?: Array<string | null> | null, listScale?: Array<string | null> | null, listPurification?: Array<string | null> | null, listModification?: Array<string | null> | null, listFormat?: Array<string | null> | null, listConcentration?: Array<string | null> | null, listTubes?: Array<string | null> | null, listMinimumYield?: number | null, listAmount?: Array<string | null> | null, listPurityLevel?: Array<string | null> | null, listNterminalMod?: Array<string | null> | null, listCterminalMod?: Array<string | null> | null, listQuantitation?: Array<string | null> | null, listInternalMod?: Array<string | null> | null, listOverhang?: Array<string | null> | null, baseCount?: number | null, antisenseBaseCount?: number | null, molecularWeight?: string | null, primerDimer?: string | null, meltingTemperature?: string | null, secondaryStructure?: string | null, gcContent?: string | null, antisenseMolecularWeight?: string | null, antisensePrimerDimer?: string | null, antisenseMeltingTemperature?: string | null, antisenseGcContent?: string | null, antisenseSecondaryStructure?: string | null, listErrors?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null, listWarning?: Array<{ __typename?: 'ListWarning', key?: string | null, value?: string | null } | null> | null, serverError?: { __typename?: 'ListError', key?: string | null, value?: string | null } | null } };

export type SimpleAntiseraTotalValidationMutationVariables = Types.Exact<{
  input: Array<Types.InputMaybe<Types.SimpleAntiseraSessionInput>> | Types.InputMaybe<Types.SimpleAntiseraSessionInput>;
  productInput: Types.ConfiguratorProductInput;
}>;


export type SimpleAntiseraTotalValidationMutation = { __typename?: 'Mutation', simpleAntiseraTotalValidation?: Array<{ __typename?: 'SimpleAntiseraTotalValidationResponse', listAntiseraPeptideModel?: Array<{ __typename?: 'AntiseraPeptideModelResponse', peptideName?: string | null, id?: string | null, amount?: string | null, sequence?: string | null, baseCount?: number | null, nterminalMod?: string | null, cterminalMod?: string | null, purityLevel?: string | null, peptideCarrierProtein?: string | null, projectType?: string | null, peptideAddSpecification?: string | null, terms?: boolean | null, listPeptideCarrierProtein?: Array<string | null> | null, listError?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null } | null> | null, listError?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null }> | null };

export type GenomicsFileUploadMutationVariables = Types.Exact<{
  input: Types.Scalars['String']['input'];
  productInput: Types.ConfiguratorProductInput;
  startRow?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GenomicsFileUploadMutation = { __typename?: 'Mutation', genomicsFileUpload?: { __typename?: 'UploadFileResponse', key?: string | null, value?: string | null, serverError?: { __typename?: 'ListError', key?: string | null, value?: string | null } | null } | null };

export type AntiseraSaveToSessionMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Array<Types.InputMaybe<Types.AntiseraSessionInput>> | Types.InputMaybe<Types.AntiseraSessionInput>>;
  productInput: Types.ConfiguratorProductInput;
}>;


export type AntiseraSaveToSessionMutation = { __typename?: 'Mutation', antiseraSaveToSession?: { __typename?: 'SessionResponse', result?: number | null } | null };

export type AntiseraTotalValidationMutationVariables = Types.Exact<{
  input: Array<Types.InputMaybe<Types.AntiseraSessionInput>> | Types.InputMaybe<Types.AntiseraSessionInput>;
  productInput: Types.ConfiguratorProductInput;
}>;


export type AntiseraTotalValidationMutation = { __typename?: 'Mutation', antiseraTotalValidation?: Array<{ __typename?: 'AntiseraTotalValidationResponse', projectType?: string | null, peptide?: string | null, listPurificationColumn?: Array<string | null> | null, listPurificationType?: Array<string | null> | null, listAbsorptionType?: Array<string | null> | null, listAbsorptionColumn?: Array<string | null> | null, listNoOfColumns?: Array<string | null> | null, listNumberOfAnimals?: Array<string | null> | null, listAnimalType?: Array<string | null> | null, listImmunizationTerm?: Array<string | null> | null, listPeptide?: Array<string | null> | null, listAntiseraPeptideModel?: Array<{ __typename?: 'AntiseraPeptideModelResponse', peptideName?: string | null, id?: string | null, amount?: string | null, sequence?: string | null, baseCount?: number | null, nterminalMod?: string | null, cterminalMod?: string | null, purityLevel?: string | null, peptideCarrierProtein?: string | null, projectType?: string | null, peptideAddSpecification?: string | null, terms?: boolean | null, listPeptideCarrierProtein?: Array<string | null> | null, listError?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null } | null> | null, listError?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null, serverError?: { __typename?: 'ListError', key?: string | null, value?: string | null } | null }> | null };

export type AntiseraEmailCartMutationVariables = Types.Exact<{
  input: Array<Types.InputMaybe<Types.AntiseraSessionInput>> | Types.InputMaybe<Types.AntiseraSessionInput>;
}>;


export type AntiseraEmailCartMutation = { __typename?: 'Mutation', antiseraEmailCart?: boolean | null };

export type GetAntiseraPriceCallMutationVariables = Types.Exact<{
  product: Types.ConfiguratorProductInput;
}>;


export type GetAntiseraPriceCallMutation = { __typename?: 'Mutation', getAntiseraPriceCall?: { __typename?: 'AntiseraPriceResponse', response?: Array<{ __typename?: 'AntiseraPrice', currencySymbol?: string | null, currency?: string | null, brand?: string | null, material?: string | null, price?: string | null, projectBaseFee?: string | null, elisaFee?: string | null, colConstructionFee?: string | null, purificationFee?: string | null, adsorptionFee?: string | null, subtotal?: string | null, priceHeaderError?: string | null, listPeptideError?: Array<{ __typename?: 'PeptideErrors', listError?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null } | null> | null, listError?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null } | null> | null, serverError?: { __typename?: 'ListError', key?: string | null, value?: string | null } | null } | null };

export type AntiseraPriceResponseFragment = { __typename?: 'AntiseraPriceResponse', response?: Array<{ __typename?: 'AntiseraPrice', currencySymbol?: string | null, currency?: string | null, brand?: string | null, material?: string | null, price?: string | null, projectBaseFee?: string | null, elisaFee?: string | null, colConstructionFee?: string | null, purificationFee?: string | null, adsorptionFee?: string | null, subtotal?: string | null, priceHeaderError?: string | null, listPeptideError?: Array<{ __typename?: 'PeptideErrors', listError?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null } | null> | null, listError?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null } | null> | null, serverError?: { __typename?: 'ListError', key?: string | null, value?: string | null } | null };

export type NgsoCopyPasteMutationVariables = Types.Exact<{
  input: Types.Scalars['String']['input'];
  productInput: Types.ConfiguratorProductInput;
  isOverride?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  isDForm?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type NgsoCopyPasteMutation = { __typename?: 'Mutation', ngsoCopyPaste?: { __typename?: 'UploadCopyPasteResponse', key?: string | null, value?: string | null, serverError?: { __typename?: 'ListError', key?: string | null, value?: string | null } | null } | null };

export type NgsoFileUploadMutationVariables = Types.Exact<{
  input: Types.Scalars['String']['input'];
  productInput: Types.ConfiguratorProductInput;
  isOverride?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  isDForm?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  startRow?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type NgsoFileUploadMutation = { __typename?: 'Mutation', ngsoFileUpload?: { __typename?: 'UploadFileResponse', key?: string | null, value?: string | null, serverError?: { __typename?: 'ListError', key?: string | null, value?: string | null } | null } | null };

export const PlatesDataResponseFragmentDoc = gql`
    fragment PlatesDataResponse on PlatesDataResponse {
  response {
    error
    wellList {
      id
      oligoId
      countryCode
      listNgso
      listError {
        key
        value
      }
      errorType
    }
    biTubeWellList {
      id
      oligoId
      countryCode
      listError {
        key
        value
      }
      listWarning {
        key
        value
      }
      errorType
    }
  }
  serverError {
    key
    value
  }
}
    `;
export const TubePriceCallFragmentDoc = gql`
    fragment TubePriceCall on TubePriceCall {
  result {
    listErrors {
      key
      value
    }
    epsilon
    listFiveMod
    listThreeMod
    listScale
    listPurification
    listModification
    listFormat
    listConcentration
    listTubes
    listMinimumYield
    listAmount
    listPurityLevel
    listNterminalMod
    listCterminalMod
    listQuantitation
    listInternalMod
    baseCount
    molecularWeight
    primerDimer
    meltingTemperature
    secondaryStructure
    gcContent
    isOverridden
    name
    sequence
    fiveMod
    purification
    format
    concentration
    tubes
    price
    scale
    applyToAll
    fullSOligoBackbone
    productType
    threeMod
    countryCode
    currencySymbol
    currency
    material
    brand
    priceHeaderError
    cartId
    itemId
    oligoId
    serverError {
      key
      value
    }
  }
}
    `;
export const WellSpecificationResponseFragmentDoc = gql`
    fragment WellSpecificationResponse on WellSpecificationResponse {
  response {
    id
    listPurification
    listScale
    listFormat
    listAmount
  }
  serverError {
    key
    value
  }
}
    `;
export const BiWellSpecificationResponseFragmentDoc = gql`
    fragment BiWellSpecificationResponse on WellSpecificationResponse {
  response {
    id
    listPurification
    listScale
    listFormat
    listAmount
  }
  serverError {
    key
    value
  }
}
    `;
export const AntiseraPriceResponseFragmentDoc = gql`
    fragment AntiseraPriceResponse on AntiseraPriceResponse {
  response {
    currencySymbol
    currency
    brand
    material
    price
    projectBaseFee
    elisaFee
    colConstructionFee
    purificationFee
    adsorptionFee
    subtotal
    listPeptideError {
      listError {
        key
        value
      }
    }
    listError {
      key
      value
    }
    priceHeaderError
  }
  serverError {
    key
    value
  }
}
    `;
export const RuleValidateFieldsDocument = gql`
    mutation RuleValidateFields($input: RuleValidateInput!, $productInput: ConfiguratorProductInput!) {
  ruleValidateFields(input: $input, productInput: $productInput) {
    listErrors {
      key
      value
    }
    listWarnings {
      key
      value
    }
    listFiveMod
    listThreeMod
    listScale
    listPurification
    listModification
    listFormat
    listConcentration
    listTubes
    listMinimumYield
    listAmount
    listPurityLevel
    listNterminalMod
    listCterminalMod
    listQuantitation
    listInternalMod
    baseCount
    molecularWeight
    primerDimer
    meltingTemperature
    secondaryStructure
    gcContent
    listLabeledAminoAcids
    listConjugation
    listConjugationAmount
    listConjugationChemistry
    listAdditionalCarrierProtein
    listServices
    listAdditionalServices
    additionalServices
    sequence
    isLNABaseEnable
    serverError {
      key
      value
    }
  }
}
    `;
export type RuleValidateFieldsMutationFn = Apollo.MutationFunction<RuleValidateFieldsMutation, RuleValidateFieldsMutationVariables>;
export type RuleValidateFieldsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<RuleValidateFieldsMutation, RuleValidateFieldsMutationVariables>, 'mutation'>;

    export const RuleValidateFieldsComponent = (props: RuleValidateFieldsComponentProps) => (
      <ApolloReactComponents.Mutation<RuleValidateFieldsMutation, RuleValidateFieldsMutationVariables> mutation={RuleValidateFieldsDocument} {...props} />
    );
    

/**
 * __useRuleValidateFieldsMutation__
 *
 * To run a mutation, you first call `useRuleValidateFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRuleValidateFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ruleValidateFieldsMutation, { data, loading, error }] = useRuleValidateFieldsMutation({
 *   variables: {
 *      input: // value for 'input'
 *      productInput: // value for 'productInput'
 *   },
 * });
 */
export function useRuleValidateFieldsMutation(baseOptions?: Apollo.MutationHookOptions<RuleValidateFieldsMutation, RuleValidateFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RuleValidateFieldsMutation, RuleValidateFieldsMutationVariables>(RuleValidateFieldsDocument, options);
      }
export type RuleValidateFieldsMutationHookResult = ReturnType<typeof useRuleValidateFieldsMutation>;
export type RuleValidateFieldsMutationResult = Apollo.MutationResult<RuleValidateFieldsMutation>;
export type RuleValidateFieldsMutationOptions = Apollo.BaseMutationOptions<RuleValidateFieldsMutation, RuleValidateFieldsMutationVariables>;
export const SessionFieldsDocument = gql`
    mutation SessionFields($input: [SessionInput]!, $productInput: ConfiguratorProductInput!) {
  sessionFields(input: $input, productInput: $productInput) {
    result
  }
}
    `;
export type SessionFieldsMutationFn = Apollo.MutationFunction<SessionFieldsMutation, SessionFieldsMutationVariables>;
export type SessionFieldsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SessionFieldsMutation, SessionFieldsMutationVariables>, 'mutation'>;

    export const SessionFieldsComponent = (props: SessionFieldsComponentProps) => (
      <ApolloReactComponents.Mutation<SessionFieldsMutation, SessionFieldsMutationVariables> mutation={SessionFieldsDocument} {...props} />
    );
    

/**
 * __useSessionFieldsMutation__
 *
 * To run a mutation, you first call `useSessionFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSessionFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sessionFieldsMutation, { data, loading, error }] = useSessionFieldsMutation({
 *   variables: {
 *      input: // value for 'input'
 *      productInput: // value for 'productInput'
 *   },
 * });
 */
export function useSessionFieldsMutation(baseOptions?: Apollo.MutationHookOptions<SessionFieldsMutation, SessionFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SessionFieldsMutation, SessionFieldsMutationVariables>(SessionFieldsDocument, options);
      }
export type SessionFieldsMutationHookResult = ReturnType<typeof useSessionFieldsMutation>;
export type SessionFieldsMutationResult = Apollo.MutationResult<SessionFieldsMutation>;
export type SessionFieldsMutationOptions = Apollo.BaseMutationOptions<SessionFieldsMutation, SessionFieldsMutationVariables>;
export const TubeTotalValidationDocument = gql`
    mutation tubeTotalValidation($input: [SessionInput]!, $productInput: ConfiguratorProductInput!) {
  tubeTotalValidation(input: $input, productInput: $productInput) {
    oligoId
    epsilon
    listErrors {
      key
      value
    }
    serverError {
      key
      value
    }
  }
}
    `;
export type TubeTotalValidationMutationFn = Apollo.MutationFunction<TubeTotalValidationMutation, TubeTotalValidationMutationVariables>;
export type TubeTotalValidationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<TubeTotalValidationMutation, TubeTotalValidationMutationVariables>, 'mutation'>;

    export const TubeTotalValidationComponent = (props: TubeTotalValidationComponentProps) => (
      <ApolloReactComponents.Mutation<TubeTotalValidationMutation, TubeTotalValidationMutationVariables> mutation={TubeTotalValidationDocument} {...props} />
    );
    

/**
 * __useTubeTotalValidationMutation__
 *
 * To run a mutation, you first call `useTubeTotalValidationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTubeTotalValidationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tubeTotalValidationMutation, { data, loading, error }] = useTubeTotalValidationMutation({
 *   variables: {
 *      input: // value for 'input'
 *      productInput: // value for 'productInput'
 *   },
 * });
 */
export function useTubeTotalValidationMutation(baseOptions?: Apollo.MutationHookOptions<TubeTotalValidationMutation, TubeTotalValidationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TubeTotalValidationMutation, TubeTotalValidationMutationVariables>(TubeTotalValidationDocument, options);
      }
export type TubeTotalValidationMutationHookResult = ReturnType<typeof useTubeTotalValidationMutation>;
export type TubeTotalValidationMutationResult = Apollo.MutationResult<TubeTotalValidationMutation>;
export type TubeTotalValidationMutationOptions = Apollo.BaseMutationOptions<TubeTotalValidationMutation, TubeTotalValidationMutationVariables>;
export const UploadCopyPasteTextDocument = gql`
    mutation UploadCopyPasteText($input: String, $productInput: ConfiguratorProductInput!, $isOverride: Boolean, $autogenerateAntisense: Boolean) {
  uploadCopyPasteText(
    input: $input
    productInput: $productInput
    isOverride: $isOverride
    autogenerateAntisense: $autogenerateAntisense
  ) {
    key
    value
    serverError {
      key
      value
    }
  }
}
    `;
export type UploadCopyPasteTextMutationFn = Apollo.MutationFunction<UploadCopyPasteTextMutation, UploadCopyPasteTextMutationVariables>;
export type UploadCopyPasteTextComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UploadCopyPasteTextMutation, UploadCopyPasteTextMutationVariables>, 'mutation'>;

    export const UploadCopyPasteTextComponent = (props: UploadCopyPasteTextComponentProps) => (
      <ApolloReactComponents.Mutation<UploadCopyPasteTextMutation, UploadCopyPasteTextMutationVariables> mutation={UploadCopyPasteTextDocument} {...props} />
    );
    

/**
 * __useUploadCopyPasteTextMutation__
 *
 * To run a mutation, you first call `useUploadCopyPasteTextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadCopyPasteTextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadCopyPasteTextMutation, { data, loading, error }] = useUploadCopyPasteTextMutation({
 *   variables: {
 *      input: // value for 'input'
 *      productInput: // value for 'productInput'
 *      isOverride: // value for 'isOverride'
 *      autogenerateAntisense: // value for 'autogenerateAntisense'
 *   },
 * });
 */
export function useUploadCopyPasteTextMutation(baseOptions?: Apollo.MutationHookOptions<UploadCopyPasteTextMutation, UploadCopyPasteTextMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadCopyPasteTextMutation, UploadCopyPasteTextMutationVariables>(UploadCopyPasteTextDocument, options);
      }
export type UploadCopyPasteTextMutationHookResult = ReturnType<typeof useUploadCopyPasteTextMutation>;
export type UploadCopyPasteTextMutationResult = Apollo.MutationResult<UploadCopyPasteTextMutation>;
export type UploadCopyPasteTextMutationOptions = Apollo.BaseMutationOptions<UploadCopyPasteTextMutation, UploadCopyPasteTextMutationVariables>;
export const RuleValidatePlateDocument = gql`
    mutation RuleValidatePlate($input: RuleValidatePlateInput!, $productInput: ConfiguratorProductInput!) {
  ruleValidatePlate(input: $input, productInput: $productInput) {
    listErrors {
      key
      value
    }
    listWarning {
      key
      value
    }
    listFiveMod
    listThreeMod
    listScale
    listPurification
    listModification
    listFormat
    listConcentration
    listTubes
    listMinimumYield
    listAmount
    listPurityLevel
    listNterminalMod
    listCterminalMod
    listQuantitation
    listInternalMod
    listOverhang
    baseCount
    antisenseBaseCount
    molecularWeight
    primerDimer
    meltingTemperature
    secondaryStructure
    gcContent
    antisenseMolecularWeight
    antisensePrimerDimer
    antisenseMeltingTemperature
    antisenseGcContent
    antisenseSecondaryStructure
    serverError {
      key
      value
    }
    technicalSequence
  }
}
    `;
export type RuleValidatePlateMutationFn = Apollo.MutationFunction<RuleValidatePlateMutation, RuleValidatePlateMutationVariables>;
export type RuleValidatePlateComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<RuleValidatePlateMutation, RuleValidatePlateMutationVariables>, 'mutation'>;

    export const RuleValidatePlateComponent = (props: RuleValidatePlateComponentProps) => (
      <ApolloReactComponents.Mutation<RuleValidatePlateMutation, RuleValidatePlateMutationVariables> mutation={RuleValidatePlateDocument} {...props} />
    );
    

/**
 * __useRuleValidatePlateMutation__
 *
 * To run a mutation, you first call `useRuleValidatePlateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRuleValidatePlateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ruleValidatePlateMutation, { data, loading, error }] = useRuleValidatePlateMutation({
 *   variables: {
 *      input: // value for 'input'
 *      productInput: // value for 'productInput'
 *   },
 * });
 */
export function useRuleValidatePlateMutation(baseOptions?: Apollo.MutationHookOptions<RuleValidatePlateMutation, RuleValidatePlateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RuleValidatePlateMutation, RuleValidatePlateMutationVariables>(RuleValidatePlateDocument, options);
      }
export type RuleValidatePlateMutationHookResult = ReturnType<typeof useRuleValidatePlateMutation>;
export type RuleValidatePlateMutationResult = Apollo.MutationResult<RuleValidatePlateMutation>;
export type RuleValidatePlateMutationOptions = Apollo.BaseMutationOptions<RuleValidatePlateMutation, RuleValidatePlateMutationVariables>;
export const FastduplexRuleValidationDocument = gql`
    mutation fastduplexRuleValidation($input: FastDuplexValidateInput!, $productInput: ConfiguratorProductInput!) {
  fastduplexRuleValidation(input: $input, productInput: $productInput) {
    listErrors {
      key
      value
    }
    listFiveMod
    listThreeMod
    listScale
    listPurification
    listModification
    listFormat
    listConcentration
    listTubes
    listMinimumYield
    listAmount
    listPurityLevel
    listNterminalMod
    listCterminalMod
    listQuantitation
    listInternalMod
    listOverhang
    baseCount
    molecularWeight
    primerDimer
    meltingTemperature
    secondaryStructure
    gcContent
    antisenseBaseCount
    antisenseMolecularWeight
    antisensePrimerDimer
    antisenseMeltingTemperature
    antisenseGcContent
    antisenseSecondaryStructure
    sequence
    serverError {
      key
      value
    }
  }
}
    `;
export type FastduplexRuleValidationMutationFn = Apollo.MutationFunction<FastduplexRuleValidationMutation, FastduplexRuleValidationMutationVariables>;
export type FastduplexRuleValidationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<FastduplexRuleValidationMutation, FastduplexRuleValidationMutationVariables>, 'mutation'>;

    export const FastduplexRuleValidationComponent = (props: FastduplexRuleValidationComponentProps) => (
      <ApolloReactComponents.Mutation<FastduplexRuleValidationMutation, FastduplexRuleValidationMutationVariables> mutation={FastduplexRuleValidationDocument} {...props} />
    );
    

/**
 * __useFastduplexRuleValidationMutation__
 *
 * To run a mutation, you first call `useFastduplexRuleValidationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFastduplexRuleValidationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fastduplexRuleValidationMutation, { data, loading, error }] = useFastduplexRuleValidationMutation({
 *   variables: {
 *      input: // value for 'input'
 *      productInput: // value for 'productInput'
 *   },
 * });
 */
export function useFastduplexRuleValidationMutation(baseOptions?: Apollo.MutationHookOptions<FastduplexRuleValidationMutation, FastduplexRuleValidationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FastduplexRuleValidationMutation, FastduplexRuleValidationMutationVariables>(FastduplexRuleValidationDocument, options);
      }
export type FastduplexRuleValidationMutationHookResult = ReturnType<typeof useFastduplexRuleValidationMutation>;
export type FastduplexRuleValidationMutationResult = Apollo.MutationResult<FastduplexRuleValidationMutation>;
export type FastduplexRuleValidationMutationOptions = Apollo.BaseMutationOptions<FastduplexRuleValidationMutation, FastduplexRuleValidationMutationVariables>;
export const PlateSessionFieldDocument = gql`
    mutation PlateSessionField($input: [PlatesInput]!, $productInput: ConfiguratorProductInput!) {
  plateSessionField(input: $input, productInput: $productInput)
}
    `;
export type PlateSessionFieldMutationFn = Apollo.MutationFunction<PlateSessionFieldMutation, PlateSessionFieldMutationVariables>;
export type PlateSessionFieldComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<PlateSessionFieldMutation, PlateSessionFieldMutationVariables>, 'mutation'>;

    export const PlateSessionFieldComponent = (props: PlateSessionFieldComponentProps) => (
      <ApolloReactComponents.Mutation<PlateSessionFieldMutation, PlateSessionFieldMutationVariables> mutation={PlateSessionFieldDocument} {...props} />
    );
    

/**
 * __usePlateSessionFieldMutation__
 *
 * To run a mutation, you first call `usePlateSessionFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlateSessionFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [plateSessionFieldMutation, { data, loading, error }] = usePlateSessionFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *      productInput: // value for 'productInput'
 *   },
 * });
 */
export function usePlateSessionFieldMutation(baseOptions?: Apollo.MutationHookOptions<PlateSessionFieldMutation, PlateSessionFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlateSessionFieldMutation, PlateSessionFieldMutationVariables>(PlateSessionFieldDocument, options);
      }
export type PlateSessionFieldMutationHookResult = ReturnType<typeof usePlateSessionFieldMutation>;
export type PlateSessionFieldMutationResult = Apollo.MutationResult<PlateSessionFieldMutation>;
export type PlateSessionFieldMutationOptions = Apollo.BaseMutationOptions<PlateSessionFieldMutation, PlateSessionFieldMutationVariables>;
export const PlateTotalValidationDocument = gql`
    mutation plateTotalValidation($input: [PlatesInput]!, $productInput: ConfiguratorProductInput!) {
  plateTotalValidation(input: $input, productInput: $productInput) {
    ...PlatesDataResponse
  }
}
    ${PlatesDataResponseFragmentDoc}`;
export type PlateTotalValidationMutationFn = Apollo.MutationFunction<PlateTotalValidationMutation, PlateTotalValidationMutationVariables>;
export type PlateTotalValidationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<PlateTotalValidationMutation, PlateTotalValidationMutationVariables>, 'mutation'>;

    export const PlateTotalValidationComponent = (props: PlateTotalValidationComponentProps) => (
      <ApolloReactComponents.Mutation<PlateTotalValidationMutation, PlateTotalValidationMutationVariables> mutation={PlateTotalValidationDocument} {...props} />
    );
    

/**
 * __usePlateTotalValidationMutation__
 *
 * To run a mutation, you first call `usePlateTotalValidationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlateTotalValidationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [plateTotalValidationMutation, { data, loading, error }] = usePlateTotalValidationMutation({
 *   variables: {
 *      input: // value for 'input'
 *      productInput: // value for 'productInput'
 *   },
 * });
 */
export function usePlateTotalValidationMutation(baseOptions?: Apollo.MutationHookOptions<PlateTotalValidationMutation, PlateTotalValidationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlateTotalValidationMutation, PlateTotalValidationMutationVariables>(PlateTotalValidationDocument, options);
      }
export type PlateTotalValidationMutationHookResult = ReturnType<typeof usePlateTotalValidationMutation>;
export type PlateTotalValidationMutationResult = Apollo.MutationResult<PlateTotalValidationMutation>;
export type PlateTotalValidationMutationOptions = Apollo.BaseMutationOptions<PlateTotalValidationMutation, PlateTotalValidationMutationVariables>;
export const CopyPasteTubeDocument = gql`
    mutation copyPasteTube($input: String!, $productInput: ConfiguratorProductInput!, $isOverride: Boolean, $isDForm: Boolean) {
  copyPasteTube(
    input: $input
    productInput: $productInput
    isOverride: $isOverride
    isDForm: $isDForm
  ) {
    key
    value
    serverError {
      key
      value
    }
  }
}
    `;
export type CopyPasteTubeMutationFn = Apollo.MutationFunction<CopyPasteTubeMutation, CopyPasteTubeMutationVariables>;
export type CopyPasteTubeComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CopyPasteTubeMutation, CopyPasteTubeMutationVariables>, 'mutation'>;

    export const CopyPasteTubeComponent = (props: CopyPasteTubeComponentProps) => (
      <ApolloReactComponents.Mutation<CopyPasteTubeMutation, CopyPasteTubeMutationVariables> mutation={CopyPasteTubeDocument} {...props} />
    );
    

/**
 * __useCopyPasteTubeMutation__
 *
 * To run a mutation, you first call `useCopyPasteTubeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyPasteTubeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyPasteTubeMutation, { data, loading, error }] = useCopyPasteTubeMutation({
 *   variables: {
 *      input: // value for 'input'
 *      productInput: // value for 'productInput'
 *      isOverride: // value for 'isOverride'
 *      isDForm: // value for 'isDForm'
 *   },
 * });
 */
export function useCopyPasteTubeMutation(baseOptions?: Apollo.MutationHookOptions<CopyPasteTubeMutation, CopyPasteTubeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyPasteTubeMutation, CopyPasteTubeMutationVariables>(CopyPasteTubeDocument, options);
      }
export type CopyPasteTubeMutationHookResult = ReturnType<typeof useCopyPasteTubeMutation>;
export type CopyPasteTubeMutationResult = Apollo.MutationResult<CopyPasteTubeMutation>;
export type CopyPasteTubeMutationOptions = Apollo.BaseMutationOptions<CopyPasteTubeMutation, CopyPasteTubeMutationVariables>;
export const TubePriceCallDocument = gql`
    mutation tubePriceCall($input: [SessionInput]!, $productInput: ConfiguratorProductInput!) {
  tubePriceCall(input: $input, productInput: $productInput) {
    ...TubePriceCall
  }
}
    ${TubePriceCallFragmentDoc}`;
export type TubePriceCallMutationFn = Apollo.MutationFunction<TubePriceCallMutation, TubePriceCallMutationVariables>;
export type TubePriceCallComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<TubePriceCallMutation, TubePriceCallMutationVariables>, 'mutation'>;

    export const TubePriceCallComponent = (props: TubePriceCallComponentProps) => (
      <ApolloReactComponents.Mutation<TubePriceCallMutation, TubePriceCallMutationVariables> mutation={TubePriceCallDocument} {...props} />
    );
    

/**
 * __useTubePriceCallMutation__
 *
 * To run a mutation, you first call `useTubePriceCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTubePriceCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tubePriceCallMutation, { data, loading, error }] = useTubePriceCallMutation({
 *   variables: {
 *      input: // value for 'input'
 *      productInput: // value for 'productInput'
 *   },
 * });
 */
export function useTubePriceCallMutation(baseOptions?: Apollo.MutationHookOptions<TubePriceCallMutation, TubePriceCallMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TubePriceCallMutation, TubePriceCallMutationVariables>(TubePriceCallDocument, options);
      }
export type TubePriceCallMutationHookResult = ReturnType<typeof useTubePriceCallMutation>;
export type TubePriceCallMutationResult = Apollo.MutationResult<TubePriceCallMutation>;
export type TubePriceCallMutationOptions = Apollo.BaseMutationOptions<TubePriceCallMutation, TubePriceCallMutationVariables>;
export const BitubeTotalValidationDocument = gql`
    mutation bitubeTotalValidation($input: [SessionInput]!, $productInput: ConfiguratorProductInput!) {
  bitubeTotalValidation(input: $input, product: $productInput) {
    listErrors {
      key
      value
    }
    price
    currencySymbol
    currency
    brand
    material
    serverError {
      key
      value
    }
  }
}
    `;
export type BitubeTotalValidationMutationFn = Apollo.MutationFunction<BitubeTotalValidationMutation, BitubeTotalValidationMutationVariables>;
export type BitubeTotalValidationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<BitubeTotalValidationMutation, BitubeTotalValidationMutationVariables>, 'mutation'>;

    export const BitubeTotalValidationComponent = (props: BitubeTotalValidationComponentProps) => (
      <ApolloReactComponents.Mutation<BitubeTotalValidationMutation, BitubeTotalValidationMutationVariables> mutation={BitubeTotalValidationDocument} {...props} />
    );
    

/**
 * __useBitubeTotalValidationMutation__
 *
 * To run a mutation, you first call `useBitubeTotalValidationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBitubeTotalValidationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bitubeTotalValidationMutation, { data, loading, error }] = useBitubeTotalValidationMutation({
 *   variables: {
 *      input: // value for 'input'
 *      productInput: // value for 'productInput'
 *   },
 * });
 */
export function useBitubeTotalValidationMutation(baseOptions?: Apollo.MutationHookOptions<BitubeTotalValidationMutation, BitubeTotalValidationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BitubeTotalValidationMutation, BitubeTotalValidationMutationVariables>(BitubeTotalValidationDocument, options);
      }
export type BitubeTotalValidationMutationHookResult = ReturnType<typeof useBitubeTotalValidationMutation>;
export type BitubeTotalValidationMutationResult = Apollo.MutationResult<BitubeTotalValidationMutation>;
export type BitubeTotalValidationMutationOptions = Apollo.BaseMutationOptions<BitubeTotalValidationMutation, BitubeTotalValidationMutationVariables>;
export const UploadTubesFromFileDocument = gql`
    mutation uploadTubesFromFile($input: String!, $productInput: ConfiguratorProductInput!, $isOverride: Boolean, $isDForm: Boolean, $startRow: Int) {
  uploadTubesFromFile(
    input: $input
    productInput: $productInput
    isOverride: $isOverride
    isDForm: $isDForm
    startRow: $startRow
  ) {
    key
    value
    serverError {
      key
      value
    }
  }
}
    `;
export type UploadTubesFromFileMutationFn = Apollo.MutationFunction<UploadTubesFromFileMutation, UploadTubesFromFileMutationVariables>;
export type UploadTubesFromFileComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UploadTubesFromFileMutation, UploadTubesFromFileMutationVariables>, 'mutation'>;

    export const UploadTubesFromFileComponent = (props: UploadTubesFromFileComponentProps) => (
      <ApolloReactComponents.Mutation<UploadTubesFromFileMutation, UploadTubesFromFileMutationVariables> mutation={UploadTubesFromFileDocument} {...props} />
    );
    

/**
 * __useUploadTubesFromFileMutation__
 *
 * To run a mutation, you first call `useUploadTubesFromFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadTubesFromFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadTubesFromFileMutation, { data, loading, error }] = useUploadTubesFromFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *      productInput: // value for 'productInput'
 *      isOverride: // value for 'isOverride'
 *      isDForm: // value for 'isDForm'
 *      startRow: // value for 'startRow'
 *   },
 * });
 */
export function useUploadTubesFromFileMutation(baseOptions?: Apollo.MutationHookOptions<UploadTubesFromFileMutation, UploadTubesFromFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadTubesFromFileMutation, UploadTubesFromFileMutationVariables>(UploadTubesFromFileDocument, options);
      }
export type UploadTubesFromFileMutationHookResult = ReturnType<typeof useUploadTubesFromFileMutation>;
export type UploadTubesFromFileMutationResult = Apollo.MutationResult<UploadTubesFromFileMutation>;
export type UploadTubesFromFileMutationOptions = Apollo.BaseMutationOptions<UploadTubesFromFileMutation, UploadTubesFromFileMutationVariables>;
export const PlateSpecificationValidationDocument = gql`
    mutation plateSpecificationValidation($input: [WelllistInput], $productInput: ConfiguratorProductInput!) {
  plateSpecificationValidation(input: $input, productInput: $productInput) {
    ...WellSpecificationResponse
  }
}
    ${WellSpecificationResponseFragmentDoc}`;
export type PlateSpecificationValidationMutationFn = Apollo.MutationFunction<PlateSpecificationValidationMutation, PlateSpecificationValidationMutationVariables>;
export type PlateSpecificationValidationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<PlateSpecificationValidationMutation, PlateSpecificationValidationMutationVariables>, 'mutation'>;

    export const PlateSpecificationValidationComponent = (props: PlateSpecificationValidationComponentProps) => (
      <ApolloReactComponents.Mutation<PlateSpecificationValidationMutation, PlateSpecificationValidationMutationVariables> mutation={PlateSpecificationValidationDocument} {...props} />
    );
    

/**
 * __usePlateSpecificationValidationMutation__
 *
 * To run a mutation, you first call `usePlateSpecificationValidationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlateSpecificationValidationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [plateSpecificationValidationMutation, { data, loading, error }] = usePlateSpecificationValidationMutation({
 *   variables: {
 *      input: // value for 'input'
 *      productInput: // value for 'productInput'
 *   },
 * });
 */
export function usePlateSpecificationValidationMutation(baseOptions?: Apollo.MutationHookOptions<PlateSpecificationValidationMutation, PlateSpecificationValidationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlateSpecificationValidationMutation, PlateSpecificationValidationMutationVariables>(PlateSpecificationValidationDocument, options);
      }
export type PlateSpecificationValidationMutationHookResult = ReturnType<typeof usePlateSpecificationValidationMutation>;
export type PlateSpecificationValidationMutationResult = Apollo.MutationResult<PlateSpecificationValidationMutation>;
export type PlateSpecificationValidationMutationOptions = Apollo.BaseMutationOptions<PlateSpecificationValidationMutation, PlateSpecificationValidationMutationVariables>;
export const DuplexSpecificationValidationDocument = gql`
    mutation duplexSpecificationValidation($input: [BiTubeWellListInput], $productInput: ConfiguratorProductInput!) {
  duplexSpecificationValidation(input: $input, productInput: $productInput) {
    ...BiWellSpecificationResponse
  }
}
    ${BiWellSpecificationResponseFragmentDoc}`;
export type DuplexSpecificationValidationMutationFn = Apollo.MutationFunction<DuplexSpecificationValidationMutation, DuplexSpecificationValidationMutationVariables>;
export type DuplexSpecificationValidationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DuplexSpecificationValidationMutation, DuplexSpecificationValidationMutationVariables>, 'mutation'>;

    export const DuplexSpecificationValidationComponent = (props: DuplexSpecificationValidationComponentProps) => (
      <ApolloReactComponents.Mutation<DuplexSpecificationValidationMutation, DuplexSpecificationValidationMutationVariables> mutation={DuplexSpecificationValidationDocument} {...props} />
    );
    

/**
 * __useDuplexSpecificationValidationMutation__
 *
 * To run a mutation, you first call `useDuplexSpecificationValidationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplexSpecificationValidationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplexSpecificationValidationMutation, { data, loading, error }] = useDuplexSpecificationValidationMutation({
 *   variables: {
 *      input: // value for 'input'
 *      productInput: // value for 'productInput'
 *   },
 * });
 */
export function useDuplexSpecificationValidationMutation(baseOptions?: Apollo.MutationHookOptions<DuplexSpecificationValidationMutation, DuplexSpecificationValidationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplexSpecificationValidationMutation, DuplexSpecificationValidationMutationVariables>(DuplexSpecificationValidationDocument, options);
      }
export type DuplexSpecificationValidationMutationHookResult = ReturnType<typeof useDuplexSpecificationValidationMutation>;
export type DuplexSpecificationValidationMutationResult = Apollo.MutationResult<DuplexSpecificationValidationMutation>;
export type DuplexSpecificationValidationMutationOptions = Apollo.BaseMutationOptions<DuplexSpecificationValidationMutation, DuplexSpecificationValidationMutationVariables>;
export const ValidatePlateShippingDocument = gql`
    mutation validatePlateShipping($input: [PlatesInput]!, $productInput: ConfiguratorProductInput!) {
  validatePlateShipping(input: $input, productInput: $productInput) {
    listShipment
    listExcessMaterial
    listProductPackage
    serverError {
      key
      value
    }
  }
}
    `;
export type ValidatePlateShippingMutationFn = Apollo.MutationFunction<ValidatePlateShippingMutation, ValidatePlateShippingMutationVariables>;
export type ValidatePlateShippingComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ValidatePlateShippingMutation, ValidatePlateShippingMutationVariables>, 'mutation'>;

    export const ValidatePlateShippingComponent = (props: ValidatePlateShippingComponentProps) => (
      <ApolloReactComponents.Mutation<ValidatePlateShippingMutation, ValidatePlateShippingMutationVariables> mutation={ValidatePlateShippingDocument} {...props} />
    );
    

/**
 * __useValidatePlateShippingMutation__
 *
 * To run a mutation, you first call `useValidatePlateShippingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidatePlateShippingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validatePlateShippingMutation, { data, loading, error }] = useValidatePlateShippingMutation({
 *   variables: {
 *      input: // value for 'input'
 *      productInput: // value for 'productInput'
 *   },
 * });
 */
export function useValidatePlateShippingMutation(baseOptions?: Apollo.MutationHookOptions<ValidatePlateShippingMutation, ValidatePlateShippingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidatePlateShippingMutation, ValidatePlateShippingMutationVariables>(ValidatePlateShippingDocument, options);
      }
export type ValidatePlateShippingMutationHookResult = ReturnType<typeof useValidatePlateShippingMutation>;
export type ValidatePlateShippingMutationResult = Apollo.MutationResult<ValidatePlateShippingMutation>;
export type ValidatePlateShippingMutationOptions = Apollo.BaseMutationOptions<ValidatePlateShippingMutation, ValidatePlateShippingMutationVariables>;
export const BiTubePriceCallDocument = gql`
    mutation biTubePriceCall($product: ConfiguratorProductInput!) {
  biTubePriceCall(product: $product) {
    listErrors {
      key
      value
    }
    price
    currencySymbol
    currency
    material
    brand
    priceHeaderError
    serverError {
      key
      value
    }
  }
}
    `;
export type BiTubePriceCallMutationFn = Apollo.MutationFunction<BiTubePriceCallMutation, BiTubePriceCallMutationVariables>;
export type BiTubePriceCallComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<BiTubePriceCallMutation, BiTubePriceCallMutationVariables>, 'mutation'>;

    export const BiTubePriceCallComponent = (props: BiTubePriceCallComponentProps) => (
      <ApolloReactComponents.Mutation<BiTubePriceCallMutation, BiTubePriceCallMutationVariables> mutation={BiTubePriceCallDocument} {...props} />
    );
    

/**
 * __useBiTubePriceCallMutation__
 *
 * To run a mutation, you first call `useBiTubePriceCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBiTubePriceCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [biTubePriceCallMutation, { data, loading, error }] = useBiTubePriceCallMutation({
 *   variables: {
 *      product: // value for 'product'
 *   },
 * });
 */
export function useBiTubePriceCallMutation(baseOptions?: Apollo.MutationHookOptions<BiTubePriceCallMutation, BiTubePriceCallMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BiTubePriceCallMutation, BiTubePriceCallMutationVariables>(BiTubePriceCallDocument, options);
      }
export type BiTubePriceCallMutationHookResult = ReturnType<typeof useBiTubePriceCallMutation>;
export type BiTubePriceCallMutationResult = Apollo.MutationResult<BiTubePriceCallMutation>;
export type BiTubePriceCallMutationOptions = Apollo.BaseMutationOptions<BiTubePriceCallMutation, BiTubePriceCallMutationVariables>;
export const FileUploadPlateDocument = gql`
    mutation fileUploadPlate($input: [PlateListInput]!, $productInput: ConfiguratorProductInput!, $isOverride: Boolean, $autogenerateAntisense: Boolean, $startRow: Int) {
  fileUploadPlate(
    input: $input
    productInput: $productInput
    isOverride: $isOverride
    autogenerateAntisense: $autogenerateAntisense
    startRow: $startRow
  ) {
    key
    value
    serverError {
      key
      value
    }
  }
}
    `;
export type FileUploadPlateMutationFn = Apollo.MutationFunction<FileUploadPlateMutation, FileUploadPlateMutationVariables>;
export type FileUploadPlateComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<FileUploadPlateMutation, FileUploadPlateMutationVariables>, 'mutation'>;

    export const FileUploadPlateComponent = (props: FileUploadPlateComponentProps) => (
      <ApolloReactComponents.Mutation<FileUploadPlateMutation, FileUploadPlateMutationVariables> mutation={FileUploadPlateDocument} {...props} />
    );
    

/**
 * __useFileUploadPlateMutation__
 *
 * To run a mutation, you first call `useFileUploadPlateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFileUploadPlateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fileUploadPlateMutation, { data, loading, error }] = useFileUploadPlateMutation({
 *   variables: {
 *      input: // value for 'input'
 *      productInput: // value for 'productInput'
 *      isOverride: // value for 'isOverride'
 *      autogenerateAntisense: // value for 'autogenerateAntisense'
 *      startRow: // value for 'startRow'
 *   },
 * });
 */
export function useFileUploadPlateMutation(baseOptions?: Apollo.MutationHookOptions<FileUploadPlateMutation, FileUploadPlateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FileUploadPlateMutation, FileUploadPlateMutationVariables>(FileUploadPlateDocument, options);
      }
export type FileUploadPlateMutationHookResult = ReturnType<typeof useFileUploadPlateMutation>;
export type FileUploadPlateMutationResult = Apollo.MutationResult<FileUploadPlateMutation>;
export type FileUploadPlateMutationOptions = Apollo.BaseMutationOptions<FileUploadPlateMutation, FileUploadPlateMutationVariables>;
export const ConfAddToMiniCartDocument = gql`
    mutation confAddToMiniCart($input: configuratorAddToMiniCartInput!) {
  confAddToMiniCart(input: $input) {
    result
    serverError {
      key
      value
    }
  }
}
    `;
export type ConfAddToMiniCartMutationFn = Apollo.MutationFunction<ConfAddToMiniCartMutation, ConfAddToMiniCartMutationVariables>;
export type ConfAddToMiniCartComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ConfAddToMiniCartMutation, ConfAddToMiniCartMutationVariables>, 'mutation'>;

    export const ConfAddToMiniCartComponent = (props: ConfAddToMiniCartComponentProps) => (
      <ApolloReactComponents.Mutation<ConfAddToMiniCartMutation, ConfAddToMiniCartMutationVariables> mutation={ConfAddToMiniCartDocument} {...props} />
    );
    

/**
 * __useConfAddToMiniCartMutation__
 *
 * To run a mutation, you first call `useConfAddToMiniCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfAddToMiniCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confAddToMiniCartMutation, { data, loading, error }] = useConfAddToMiniCartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfAddToMiniCartMutation(baseOptions?: Apollo.MutationHookOptions<ConfAddToMiniCartMutation, ConfAddToMiniCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfAddToMiniCartMutation, ConfAddToMiniCartMutationVariables>(ConfAddToMiniCartDocument, options);
      }
export type ConfAddToMiniCartMutationHookResult = ReturnType<typeof useConfAddToMiniCartMutation>;
export type ConfAddToMiniCartMutationResult = Apollo.MutationResult<ConfAddToMiniCartMutation>;
export type ConfAddToMiniCartMutationOptions = Apollo.BaseMutationOptions<ConfAddToMiniCartMutation, ConfAddToMiniCartMutationVariables>;
export const MilliplexTotalValidationDocument = gql`
    mutation milliplexTotalValidation($input: [milliplexDataInput], $productInput: ConfiguratorProductInput!) {
  milliplexTotalValidation(input: $input, productInput: $productInput) {
    listResearchAreas
    listSpecies
    checkedProductIdList
    listAnalytes
    listSensitivity
    researchAreas
    currencySymbol
    brand
    currency
    analytes
    listWarning
    listError {
      key
      value
    }
    species
    sensitivity
    mapMates
    itemId
    cartId
    comments
    additionalComments
    productType
    countryCode
    priceHeaderError
    oligoId
    researcher
    id
    listMilliplexAssayModel {
      requestDate
      responseDate
      count
      version
      term
      termCount
      assays {
        panelId
        panelName
        assayType
        customPremixedAvailable
        requireSample
        researchAreaOracle
        species
        researchAreas
        type
        listSampleType
        customPremixSelection
        spaceSaverSelection
        decisionTableVer
        listSearchResultModelErrors {
          key
          value
        }
        listWarnings {
          key
          value
        }
        listAnalytes
        selectedAnalytes
        price
        allAnalytesSelected
        mutualAnalytesList
        analytes
        quantity
        material
        spaceSaver
        name
        sampleType
        id
        productTotal
      }
    }
    serverError {
      key
      value
    }
  }
}
    `;
export type MilliplexTotalValidationMutationFn = Apollo.MutationFunction<MilliplexTotalValidationMutation, MilliplexTotalValidationMutationVariables>;
export type MilliplexTotalValidationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<MilliplexTotalValidationMutation, MilliplexTotalValidationMutationVariables>, 'mutation'>;

    export const MilliplexTotalValidationComponent = (props: MilliplexTotalValidationComponentProps) => (
      <ApolloReactComponents.Mutation<MilliplexTotalValidationMutation, MilliplexTotalValidationMutationVariables> mutation={MilliplexTotalValidationDocument} {...props} />
    );
    

/**
 * __useMilliplexTotalValidationMutation__
 *
 * To run a mutation, you first call `useMilliplexTotalValidationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMilliplexTotalValidationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [milliplexTotalValidationMutation, { data, loading, error }] = useMilliplexTotalValidationMutation({
 *   variables: {
 *      input: // value for 'input'
 *      productInput: // value for 'productInput'
 *   },
 * });
 */
export function useMilliplexTotalValidationMutation(baseOptions?: Apollo.MutationHookOptions<MilliplexTotalValidationMutation, MilliplexTotalValidationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MilliplexTotalValidationMutation, MilliplexTotalValidationMutationVariables>(MilliplexTotalValidationDocument, options);
      }
export type MilliplexTotalValidationMutationHookResult = ReturnType<typeof useMilliplexTotalValidationMutation>;
export type MilliplexTotalValidationMutationResult = Apollo.MutationResult<MilliplexTotalValidationMutation>;
export type MilliplexTotalValidationMutationOptions = Apollo.BaseMutationOptions<MilliplexTotalValidationMutation, MilliplexTotalValidationMutationVariables>;
export const CustomCrisprTotalValidationDocument = gql`
    mutation customCrisprTotalValidation($input: [CustomCrisprSessionInput]!, $productInput: ConfiguratorProductInput!) {
  customCrisprTotalValidation(input: $input, productInput: $productInput) {
    listError {
      key
      value
    }
    listCompanionProducts {
      key
      value
    }
    listSubModels {
      name
      geneId
      geneSymbol
      sequence
      id
      isOverridden
      isCurrentForm
      baseCount
      cartId
      itemId
      listSubModelErrors {
        key
        value
      }
    }
    listPhysicalMaterials
    physicalMaterial
    listLentiviralBackbones
    listViralTiters
    listVolumes
    listAliquotings
    listVectors
    listAmount
    listSpecies
    listPurification
    listScale
    listModification
    listStructure
    listFormat
    vector
    lentiviralBackbone
    viralTiter
    volume
    aliquoting
    amount
    pageNo
    scale
    purification
    format
    modification
    species
    structure
    material
    serverError {
      key
      value
    }
    itemId
    cartId
    modifiedSequence
    modifiedTechnicalSequence
  }
}
    `;
export type CustomCrisprTotalValidationMutationFn = Apollo.MutationFunction<CustomCrisprTotalValidationMutation, CustomCrisprTotalValidationMutationVariables>;
export type CustomCrisprTotalValidationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CustomCrisprTotalValidationMutation, CustomCrisprTotalValidationMutationVariables>, 'mutation'>;

    export const CustomCrisprTotalValidationComponent = (props: CustomCrisprTotalValidationComponentProps) => (
      <ApolloReactComponents.Mutation<CustomCrisprTotalValidationMutation, CustomCrisprTotalValidationMutationVariables> mutation={CustomCrisprTotalValidationDocument} {...props} />
    );
    

/**
 * __useCustomCrisprTotalValidationMutation__
 *
 * To run a mutation, you first call `useCustomCrisprTotalValidationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomCrisprTotalValidationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customCrisprTotalValidationMutation, { data, loading, error }] = useCustomCrisprTotalValidationMutation({
 *   variables: {
 *      input: // value for 'input'
 *      productInput: // value for 'productInput'
 *   },
 * });
 */
export function useCustomCrisprTotalValidationMutation(baseOptions?: Apollo.MutationHookOptions<CustomCrisprTotalValidationMutation, CustomCrisprTotalValidationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomCrisprTotalValidationMutation, CustomCrisprTotalValidationMutationVariables>(CustomCrisprTotalValidationDocument, options);
      }
export type CustomCrisprTotalValidationMutationHookResult = ReturnType<typeof useCustomCrisprTotalValidationMutation>;
export type CustomCrisprTotalValidationMutationResult = Apollo.MutationResult<CustomCrisprTotalValidationMutation>;
export type CustomCrisprTotalValidationMutationOptions = Apollo.BaseMutationOptions<CustomCrisprTotalValidationMutation, CustomCrisprTotalValidationMutationVariables>;
export const CustomCrisprSaveToSessionDocument = gql`
    mutation customCrisprSaveToSession($input: [CustomCrisprSessionInput]!, $productInput: ConfiguratorProductInput!) {
  customCrisprSaveToSession(input: $input, productInput: $productInput) {
    result
  }
}
    `;
export type CustomCrisprSaveToSessionMutationFn = Apollo.MutationFunction<CustomCrisprSaveToSessionMutation, CustomCrisprSaveToSessionMutationVariables>;
export type CustomCrisprSaveToSessionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CustomCrisprSaveToSessionMutation, CustomCrisprSaveToSessionMutationVariables>, 'mutation'>;

    export const CustomCrisprSaveToSessionComponent = (props: CustomCrisprSaveToSessionComponentProps) => (
      <ApolloReactComponents.Mutation<CustomCrisprSaveToSessionMutation, CustomCrisprSaveToSessionMutationVariables> mutation={CustomCrisprSaveToSessionDocument} {...props} />
    );
    

/**
 * __useCustomCrisprSaveToSessionMutation__
 *
 * To run a mutation, you first call `useCustomCrisprSaveToSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomCrisprSaveToSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customCrisprSaveToSessionMutation, { data, loading, error }] = useCustomCrisprSaveToSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *      productInput: // value for 'productInput'
 *   },
 * });
 */
export function useCustomCrisprSaveToSessionMutation(baseOptions?: Apollo.MutationHookOptions<CustomCrisprSaveToSessionMutation, CustomCrisprSaveToSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomCrisprSaveToSessionMutation, CustomCrisprSaveToSessionMutationVariables>(CustomCrisprSaveToSessionDocument, options);
      }
export type CustomCrisprSaveToSessionMutationHookResult = ReturnType<typeof useCustomCrisprSaveToSessionMutation>;
export type CustomCrisprSaveToSessionMutationResult = Apollo.MutationResult<CustomCrisprSaveToSessionMutation>;
export type CustomCrisprSaveToSessionMutationOptions = Apollo.BaseMutationOptions<CustomCrisprSaveToSessionMutation, CustomCrisprSaveToSessionMutationVariables>;
export const MilliplexSaveToSessionDocument = gql`
    mutation milliplexSaveToSession($input: [milliplexDataInput], $productInput: ConfiguratorProductInput!) {
  milliplexSaveToSession(input: $input, productInput: $productInput) {
    result
  }
}
    `;
export type MilliplexSaveToSessionMutationFn = Apollo.MutationFunction<MilliplexSaveToSessionMutation, MilliplexSaveToSessionMutationVariables>;
export type MilliplexSaveToSessionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<MilliplexSaveToSessionMutation, MilliplexSaveToSessionMutationVariables>, 'mutation'>;

    export const MilliplexSaveToSessionComponent = (props: MilliplexSaveToSessionComponentProps) => (
      <ApolloReactComponents.Mutation<MilliplexSaveToSessionMutation, MilliplexSaveToSessionMutationVariables> mutation={MilliplexSaveToSessionDocument} {...props} />
    );
    

/**
 * __useMilliplexSaveToSessionMutation__
 *
 * To run a mutation, you first call `useMilliplexSaveToSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMilliplexSaveToSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [milliplexSaveToSessionMutation, { data, loading, error }] = useMilliplexSaveToSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *      productInput: // value for 'productInput'
 *   },
 * });
 */
export function useMilliplexSaveToSessionMutation(baseOptions?: Apollo.MutationHookOptions<MilliplexSaveToSessionMutation, MilliplexSaveToSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MilliplexSaveToSessionMutation, MilliplexSaveToSessionMutationVariables>(MilliplexSaveToSessionDocument, options);
      }
export type MilliplexSaveToSessionMutationHookResult = ReturnType<typeof useMilliplexSaveToSessionMutation>;
export type MilliplexSaveToSessionMutationResult = Apollo.MutationResult<MilliplexSaveToSessionMutation>;
export type MilliplexSaveToSessionMutationOptions = Apollo.BaseMutationOptions<MilliplexSaveToSessionMutation, MilliplexSaveToSessionMutationVariables>;
export const MilliplexPriceCallDocument = gql`
    mutation milliplexPriceCall($input: [milliplexDataInput], $productInput: ConfiguratorProductInput!) {
  milliplexPriceCall(input: $input, productInput: $productInput) {
    priceHeaderError
    currencySymbol
    brand
    currency
    listMilliplexAssayModel {
      requestDate
      responseDate
      count
      version
      term
      termCount
      assays {
        panelId
        panelName
        assayType
        customPremixedAvailable
        requireSample
        researchAreaOracle
        species
        researchAreas
        type
        listSampleType
        customPremixSelection
        spaceSaverSelection
        decisionTableVer
        listSearchResultModelErrors {
          key
          value
        }
        listWarnings {
          key
          value
        }
        listAnalytes
        selectedAnalytes
        price
        allAnalytesSelected
        mutualAnalytesList
        analytes
        quantity
        material
        spaceSaver
        name
        sampleType
        id
        productTotal
      }
    }
    serverError {
      key
      value
    }
  }
}
    `;
export type MilliplexPriceCallMutationFn = Apollo.MutationFunction<MilliplexPriceCallMutation, MilliplexPriceCallMutationVariables>;
export type MilliplexPriceCallComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<MilliplexPriceCallMutation, MilliplexPriceCallMutationVariables>, 'mutation'>;

    export const MilliplexPriceCallComponent = (props: MilliplexPriceCallComponentProps) => (
      <ApolloReactComponents.Mutation<MilliplexPriceCallMutation, MilliplexPriceCallMutationVariables> mutation={MilliplexPriceCallDocument} {...props} />
    );
    

/**
 * __useMilliplexPriceCallMutation__
 *
 * To run a mutation, you first call `useMilliplexPriceCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMilliplexPriceCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [milliplexPriceCallMutation, { data, loading, error }] = useMilliplexPriceCallMutation({
 *   variables: {
 *      input: // value for 'input'
 *      productInput: // value for 'productInput'
 *   },
 * });
 */
export function useMilliplexPriceCallMutation(baseOptions?: Apollo.MutationHookOptions<MilliplexPriceCallMutation, MilliplexPriceCallMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MilliplexPriceCallMutation, MilliplexPriceCallMutationVariables>(MilliplexPriceCallDocument, options);
      }
export type MilliplexPriceCallMutationHookResult = ReturnType<typeof useMilliplexPriceCallMutation>;
export type MilliplexPriceCallMutationResult = Apollo.MutationResult<MilliplexPriceCallMutation>;
export type MilliplexPriceCallMutationOptions = Apollo.BaseMutationOptions<MilliplexPriceCallMutation, MilliplexPriceCallMutationVariables>;
export const RuleValidateDuplexDocument = gql`
    mutation RuleValidateDuplex($input: RuleValidateDuplexInput!, $productInput: ConfiguratorProductInput!) {
  ruleValidateDuplex(input: $input, productInput: $productInput) {
    listErrors {
      key
      value
    }
    listWarning {
      key
      value
    }
    listFiveMod
    listThreeMod
    listScale
    listPurification
    listModification
    listFormat
    listConcentration
    listTubes
    listMinimumYield
    listAmount
    listPurityLevel
    listNterminalMod
    listCterminalMod
    listQuantitation
    listInternalMod
    listOverhang
    baseCount
    antisenseBaseCount
    molecularWeight
    primerDimer
    meltingTemperature
    secondaryStructure
    gcContent
    antisenseMolecularWeight
    antisensePrimerDimer
    antisenseMeltingTemperature
    antisenseGcContent
    antisenseSecondaryStructure
    serverError {
      key
      value
    }
  }
}
    `;
export type RuleValidateDuplexMutationFn = Apollo.MutationFunction<RuleValidateDuplexMutation, RuleValidateDuplexMutationVariables>;
export type RuleValidateDuplexComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<RuleValidateDuplexMutation, RuleValidateDuplexMutationVariables>, 'mutation'>;

    export const RuleValidateDuplexComponent = (props: RuleValidateDuplexComponentProps) => (
      <ApolloReactComponents.Mutation<RuleValidateDuplexMutation, RuleValidateDuplexMutationVariables> mutation={RuleValidateDuplexDocument} {...props} />
    );
    

/**
 * __useRuleValidateDuplexMutation__
 *
 * To run a mutation, you first call `useRuleValidateDuplexMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRuleValidateDuplexMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ruleValidateDuplexMutation, { data, loading, error }] = useRuleValidateDuplexMutation({
 *   variables: {
 *      input: // value for 'input'
 *      productInput: // value for 'productInput'
 *   },
 * });
 */
export function useRuleValidateDuplexMutation(baseOptions?: Apollo.MutationHookOptions<RuleValidateDuplexMutation, RuleValidateDuplexMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RuleValidateDuplexMutation, RuleValidateDuplexMutationVariables>(RuleValidateDuplexDocument, options);
      }
export type RuleValidateDuplexMutationHookResult = ReturnType<typeof useRuleValidateDuplexMutation>;
export type RuleValidateDuplexMutationResult = Apollo.MutationResult<RuleValidateDuplexMutation>;
export type RuleValidateDuplexMutationOptions = Apollo.BaseMutationOptions<RuleValidateDuplexMutation, RuleValidateDuplexMutationVariables>;
export const SimpleAntiseraTotalValidationDocument = gql`
    mutation simpleAntiseraTotalValidation($input: [SimpleAntiseraSessionInput]!, $productInput: ConfiguratorProductInput!) {
  simpleAntiseraTotalValidation(input: $input, productInput: $productInput) {
    listAntiseraPeptideModel {
      peptideName
      id
      amount
      sequence
      baseCount
      nterminalMod
      cterminalMod
      purityLevel
      peptideCarrierProtein
      projectType
      peptideAddSpecification
      terms
      listPeptideCarrierProtein
      listError {
        key
        value
      }
    }
    listError {
      key
      value
    }
  }
}
    `;
export type SimpleAntiseraTotalValidationMutationFn = Apollo.MutationFunction<SimpleAntiseraTotalValidationMutation, SimpleAntiseraTotalValidationMutationVariables>;
export type SimpleAntiseraTotalValidationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SimpleAntiseraTotalValidationMutation, SimpleAntiseraTotalValidationMutationVariables>, 'mutation'>;

    export const SimpleAntiseraTotalValidationComponent = (props: SimpleAntiseraTotalValidationComponentProps) => (
      <ApolloReactComponents.Mutation<SimpleAntiseraTotalValidationMutation, SimpleAntiseraTotalValidationMutationVariables> mutation={SimpleAntiseraTotalValidationDocument} {...props} />
    );
    

/**
 * __useSimpleAntiseraTotalValidationMutation__
 *
 * To run a mutation, you first call `useSimpleAntiseraTotalValidationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSimpleAntiseraTotalValidationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [simpleAntiseraTotalValidationMutation, { data, loading, error }] = useSimpleAntiseraTotalValidationMutation({
 *   variables: {
 *      input: // value for 'input'
 *      productInput: // value for 'productInput'
 *   },
 * });
 */
export function useSimpleAntiseraTotalValidationMutation(baseOptions?: Apollo.MutationHookOptions<SimpleAntiseraTotalValidationMutation, SimpleAntiseraTotalValidationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SimpleAntiseraTotalValidationMutation, SimpleAntiseraTotalValidationMutationVariables>(SimpleAntiseraTotalValidationDocument, options);
      }
export type SimpleAntiseraTotalValidationMutationHookResult = ReturnType<typeof useSimpleAntiseraTotalValidationMutation>;
export type SimpleAntiseraTotalValidationMutationResult = Apollo.MutationResult<SimpleAntiseraTotalValidationMutation>;
export type SimpleAntiseraTotalValidationMutationOptions = Apollo.BaseMutationOptions<SimpleAntiseraTotalValidationMutation, SimpleAntiseraTotalValidationMutationVariables>;
export const GenomicsFileUploadDocument = gql`
    mutation genomicsFileUpload($input: String!, $productInput: ConfiguratorProductInput!, $startRow: Int) {
  genomicsFileUpload(
    input: $input
    productInput: $productInput
    startRow: $startRow
  ) {
    key
    value
    serverError {
      key
      value
    }
  }
}
    `;
export type GenomicsFileUploadMutationFn = Apollo.MutationFunction<GenomicsFileUploadMutation, GenomicsFileUploadMutationVariables>;
export type GenomicsFileUploadComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<GenomicsFileUploadMutation, GenomicsFileUploadMutationVariables>, 'mutation'>;

    export const GenomicsFileUploadComponent = (props: GenomicsFileUploadComponentProps) => (
      <ApolloReactComponents.Mutation<GenomicsFileUploadMutation, GenomicsFileUploadMutationVariables> mutation={GenomicsFileUploadDocument} {...props} />
    );
    

/**
 * __useGenomicsFileUploadMutation__
 *
 * To run a mutation, you first call `useGenomicsFileUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenomicsFileUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [genomicsFileUploadMutation, { data, loading, error }] = useGenomicsFileUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *      productInput: // value for 'productInput'
 *      startRow: // value for 'startRow'
 *   },
 * });
 */
export function useGenomicsFileUploadMutation(baseOptions?: Apollo.MutationHookOptions<GenomicsFileUploadMutation, GenomicsFileUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenomicsFileUploadMutation, GenomicsFileUploadMutationVariables>(GenomicsFileUploadDocument, options);
      }
export type GenomicsFileUploadMutationHookResult = ReturnType<typeof useGenomicsFileUploadMutation>;
export type GenomicsFileUploadMutationResult = Apollo.MutationResult<GenomicsFileUploadMutation>;
export type GenomicsFileUploadMutationOptions = Apollo.BaseMutationOptions<GenomicsFileUploadMutation, GenomicsFileUploadMutationVariables>;
export const AntiseraSaveToSessionDocument = gql`
    mutation antiseraSaveToSession($input: [AntiseraSessionInput], $productInput: ConfiguratorProductInput!) {
  antiseraSaveToSession(input: $input, productInput: $productInput) {
    result
  }
}
    `;
export type AntiseraSaveToSessionMutationFn = Apollo.MutationFunction<AntiseraSaveToSessionMutation, AntiseraSaveToSessionMutationVariables>;
export type AntiseraSaveToSessionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AntiseraSaveToSessionMutation, AntiseraSaveToSessionMutationVariables>, 'mutation'>;

    export const AntiseraSaveToSessionComponent = (props: AntiseraSaveToSessionComponentProps) => (
      <ApolloReactComponents.Mutation<AntiseraSaveToSessionMutation, AntiseraSaveToSessionMutationVariables> mutation={AntiseraSaveToSessionDocument} {...props} />
    );
    

/**
 * __useAntiseraSaveToSessionMutation__
 *
 * To run a mutation, you first call `useAntiseraSaveToSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAntiseraSaveToSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [antiseraSaveToSessionMutation, { data, loading, error }] = useAntiseraSaveToSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *      productInput: // value for 'productInput'
 *   },
 * });
 */
export function useAntiseraSaveToSessionMutation(baseOptions?: Apollo.MutationHookOptions<AntiseraSaveToSessionMutation, AntiseraSaveToSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AntiseraSaveToSessionMutation, AntiseraSaveToSessionMutationVariables>(AntiseraSaveToSessionDocument, options);
      }
export type AntiseraSaveToSessionMutationHookResult = ReturnType<typeof useAntiseraSaveToSessionMutation>;
export type AntiseraSaveToSessionMutationResult = Apollo.MutationResult<AntiseraSaveToSessionMutation>;
export type AntiseraSaveToSessionMutationOptions = Apollo.BaseMutationOptions<AntiseraSaveToSessionMutation, AntiseraSaveToSessionMutationVariables>;
export const AntiseraTotalValidationDocument = gql`
    mutation antiseraTotalValidation($input: [AntiseraSessionInput]!, $productInput: ConfiguratorProductInput!) {
  antiseraTotalValidation(input: $input, productInput: $productInput) {
    listAntiseraPeptideModel {
      peptideName
      id
      amount
      sequence
      baseCount
      nterminalMod
      cterminalMod
      purityLevel
      peptideCarrierProtein
      projectType
      peptideAddSpecification
      terms
      listPeptideCarrierProtein
      listError {
        key
        value
      }
    }
    projectType
    peptide
    listError {
      key
      value
    }
    listPurificationColumn
    listPurificationType
    listAbsorptionType
    listAbsorptionColumn
    listNoOfColumns
    listNumberOfAnimals
    listAnimalType
    listImmunizationTerm
    listPeptide
    serverError {
      key
      value
    }
  }
}
    `;
export type AntiseraTotalValidationMutationFn = Apollo.MutationFunction<AntiseraTotalValidationMutation, AntiseraTotalValidationMutationVariables>;
export type AntiseraTotalValidationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AntiseraTotalValidationMutation, AntiseraTotalValidationMutationVariables>, 'mutation'>;

    export const AntiseraTotalValidationComponent = (props: AntiseraTotalValidationComponentProps) => (
      <ApolloReactComponents.Mutation<AntiseraTotalValidationMutation, AntiseraTotalValidationMutationVariables> mutation={AntiseraTotalValidationDocument} {...props} />
    );
    

/**
 * __useAntiseraTotalValidationMutation__
 *
 * To run a mutation, you first call `useAntiseraTotalValidationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAntiseraTotalValidationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [antiseraTotalValidationMutation, { data, loading, error }] = useAntiseraTotalValidationMutation({
 *   variables: {
 *      input: // value for 'input'
 *      productInput: // value for 'productInput'
 *   },
 * });
 */
export function useAntiseraTotalValidationMutation(baseOptions?: Apollo.MutationHookOptions<AntiseraTotalValidationMutation, AntiseraTotalValidationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AntiseraTotalValidationMutation, AntiseraTotalValidationMutationVariables>(AntiseraTotalValidationDocument, options);
      }
export type AntiseraTotalValidationMutationHookResult = ReturnType<typeof useAntiseraTotalValidationMutation>;
export type AntiseraTotalValidationMutationResult = Apollo.MutationResult<AntiseraTotalValidationMutation>;
export type AntiseraTotalValidationMutationOptions = Apollo.BaseMutationOptions<AntiseraTotalValidationMutation, AntiseraTotalValidationMutationVariables>;
export const AntiseraEmailCartDocument = gql`
    mutation antiseraEmailCart($input: [AntiseraSessionInput]!) {
  antiseraEmailCart(input: $input)
}
    `;
export type AntiseraEmailCartMutationFn = Apollo.MutationFunction<AntiseraEmailCartMutation, AntiseraEmailCartMutationVariables>;
export type AntiseraEmailCartComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AntiseraEmailCartMutation, AntiseraEmailCartMutationVariables>, 'mutation'>;

    export const AntiseraEmailCartComponent = (props: AntiseraEmailCartComponentProps) => (
      <ApolloReactComponents.Mutation<AntiseraEmailCartMutation, AntiseraEmailCartMutationVariables> mutation={AntiseraEmailCartDocument} {...props} />
    );
    

/**
 * __useAntiseraEmailCartMutation__
 *
 * To run a mutation, you first call `useAntiseraEmailCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAntiseraEmailCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [antiseraEmailCartMutation, { data, loading, error }] = useAntiseraEmailCartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAntiseraEmailCartMutation(baseOptions?: Apollo.MutationHookOptions<AntiseraEmailCartMutation, AntiseraEmailCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AntiseraEmailCartMutation, AntiseraEmailCartMutationVariables>(AntiseraEmailCartDocument, options);
      }
export type AntiseraEmailCartMutationHookResult = ReturnType<typeof useAntiseraEmailCartMutation>;
export type AntiseraEmailCartMutationResult = Apollo.MutationResult<AntiseraEmailCartMutation>;
export type AntiseraEmailCartMutationOptions = Apollo.BaseMutationOptions<AntiseraEmailCartMutation, AntiseraEmailCartMutationVariables>;
export const GetAntiseraPriceCallDocument = gql`
    mutation getAntiseraPriceCall($product: ConfiguratorProductInput!) {
  getAntiseraPriceCall(product: $product) {
    ...AntiseraPriceResponse
  }
}
    ${AntiseraPriceResponseFragmentDoc}`;
export type GetAntiseraPriceCallMutationFn = Apollo.MutationFunction<GetAntiseraPriceCallMutation, GetAntiseraPriceCallMutationVariables>;
export type GetAntiseraPriceCallComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<GetAntiseraPriceCallMutation, GetAntiseraPriceCallMutationVariables>, 'mutation'>;

    export const GetAntiseraPriceCallComponent = (props: GetAntiseraPriceCallComponentProps) => (
      <ApolloReactComponents.Mutation<GetAntiseraPriceCallMutation, GetAntiseraPriceCallMutationVariables> mutation={GetAntiseraPriceCallDocument} {...props} />
    );
    

/**
 * __useGetAntiseraPriceCallMutation__
 *
 * To run a mutation, you first call `useGetAntiseraPriceCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetAntiseraPriceCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getAntiseraPriceCallMutation, { data, loading, error }] = useGetAntiseraPriceCallMutation({
 *   variables: {
 *      product: // value for 'product'
 *   },
 * });
 */
export function useGetAntiseraPriceCallMutation(baseOptions?: Apollo.MutationHookOptions<GetAntiseraPriceCallMutation, GetAntiseraPriceCallMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetAntiseraPriceCallMutation, GetAntiseraPriceCallMutationVariables>(GetAntiseraPriceCallDocument, options);
      }
export type GetAntiseraPriceCallMutationHookResult = ReturnType<typeof useGetAntiseraPriceCallMutation>;
export type GetAntiseraPriceCallMutationResult = Apollo.MutationResult<GetAntiseraPriceCallMutation>;
export type GetAntiseraPriceCallMutationOptions = Apollo.BaseMutationOptions<GetAntiseraPriceCallMutation, GetAntiseraPriceCallMutationVariables>;
export const NgsoCopyPasteDocument = gql`
    mutation ngsoCopyPaste($input: String!, $productInput: ConfiguratorProductInput!, $isOverride: Boolean, $isDForm: Boolean) {
  ngsoCopyPaste(
    input: $input
    productInput: $productInput
    isOverride: $isOverride
    isDForm: $isDForm
  ) {
    key
    value
    serverError {
      key
      value
    }
  }
}
    `;
export type NgsoCopyPasteMutationFn = Apollo.MutationFunction<NgsoCopyPasteMutation, NgsoCopyPasteMutationVariables>;
export type NgsoCopyPasteComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<NgsoCopyPasteMutation, NgsoCopyPasteMutationVariables>, 'mutation'>;

    export const NgsoCopyPasteComponent = (props: NgsoCopyPasteComponentProps) => (
      <ApolloReactComponents.Mutation<NgsoCopyPasteMutation, NgsoCopyPasteMutationVariables> mutation={NgsoCopyPasteDocument} {...props} />
    );
    

/**
 * __useNgsoCopyPasteMutation__
 *
 * To run a mutation, you first call `useNgsoCopyPasteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNgsoCopyPasteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ngsoCopyPasteMutation, { data, loading, error }] = useNgsoCopyPasteMutation({
 *   variables: {
 *      input: // value for 'input'
 *      productInput: // value for 'productInput'
 *      isOverride: // value for 'isOverride'
 *      isDForm: // value for 'isDForm'
 *   },
 * });
 */
export function useNgsoCopyPasteMutation(baseOptions?: Apollo.MutationHookOptions<NgsoCopyPasteMutation, NgsoCopyPasteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NgsoCopyPasteMutation, NgsoCopyPasteMutationVariables>(NgsoCopyPasteDocument, options);
      }
export type NgsoCopyPasteMutationHookResult = ReturnType<typeof useNgsoCopyPasteMutation>;
export type NgsoCopyPasteMutationResult = Apollo.MutationResult<NgsoCopyPasteMutation>;
export type NgsoCopyPasteMutationOptions = Apollo.BaseMutationOptions<NgsoCopyPasteMutation, NgsoCopyPasteMutationVariables>;
export const NgsoFileUploadDocument = gql`
    mutation ngsoFileUpload($input: String!, $productInput: ConfiguratorProductInput!, $isOverride: Boolean, $isDForm: Boolean, $startRow: Int) {
  ngsoFileUpload(
    input: $input
    productInput: $productInput
    isOverride: $isOverride
    isDForm: $isDForm
    startRow: $startRow
  ) {
    key
    value
    serverError {
      key
      value
    }
  }
}
    `;
export type NgsoFileUploadMutationFn = Apollo.MutationFunction<NgsoFileUploadMutation, NgsoFileUploadMutationVariables>;
export type NgsoFileUploadComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<NgsoFileUploadMutation, NgsoFileUploadMutationVariables>, 'mutation'>;

    export const NgsoFileUploadComponent = (props: NgsoFileUploadComponentProps) => (
      <ApolloReactComponents.Mutation<NgsoFileUploadMutation, NgsoFileUploadMutationVariables> mutation={NgsoFileUploadDocument} {...props} />
    );
    

/**
 * __useNgsoFileUploadMutation__
 *
 * To run a mutation, you first call `useNgsoFileUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNgsoFileUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ngsoFileUploadMutation, { data, loading, error }] = useNgsoFileUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *      productInput: // value for 'productInput'
 *      isOverride: // value for 'isOverride'
 *      isDForm: // value for 'isDForm'
 *      startRow: // value for 'startRow'
 *   },
 * });
 */
export function useNgsoFileUploadMutation(baseOptions?: Apollo.MutationHookOptions<NgsoFileUploadMutation, NgsoFileUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NgsoFileUploadMutation, NgsoFileUploadMutationVariables>(NgsoFileUploadDocument, options);
      }
export type NgsoFileUploadMutationHookResult = ReturnType<typeof useNgsoFileUploadMutation>;
export type NgsoFileUploadMutationResult = Apollo.MutationResult<NgsoFileUploadMutation>;
export type NgsoFileUploadMutationOptions = Apollo.BaseMutationOptions<NgsoFileUploadMutation, NgsoFileUploadMutationVariables>;